const announcement1 = {
  id: 1,
  passage: `Subject: Change in Business Hours
To: All Customers
From: Customer Service Department
Date: May 5, 2025

Dear Valued Customers,

We would like to inform you that our business hours will be adjusted starting next month to better serve our customers.

New Business Hours (<mark>Effective</mark> June 1, 2025):
Monday – Friday: 9:00 AM – 7:00 PM (<mark>Previously</mark> 8:00 AM – 6:00 PM)
Saturday: 10:00 AM – 5:00 PM (No change)
Sunday & Public Holidays: Closed

Important Notes:
- <mark>Customer service representatives</mark> will be available during business hours only.
- Online support will remain available 24/7 through our website.
- Customers with pre-scheduled appointments outside the new business hours will be contacted <mark>individually</mark>.

We appreciate your understanding and look forward to continuing to serve you. If you have any questions, please contact us at support@company.com.

Best regards,
Customer Service Department`,

  translation: `제목: 운영 시간 변경
수신: 전체 고객
발신: 고객 서비스부
날짜: 2025년 5월 5일

고객 여러분,

더 나은 서비스 제공을 위해 다음 달부터 운영 시간이 조정될 예정임을 알려드립니다.

새로운 운영 시간 (2025년 6월 1일부터 적용):

월요일 - 금요일: 9:00 AM – 7:00 PM (기존 8:00 AM – 6:00 PM)
토요일: 10:00 AM – 5:00 PM (변동 없음)
일요일 및 공휴일: 휴무

중요 사항:

고객 서비스 담당자는 운영 시간 내에만 이용 가능합니다.
온라인 지원은 웹사이트를 통해 24시간 이용 가능합니다.
새로운 운영 시간 외에 사전 예약된 고객들께는 개별적으로 연락드릴 예정입니다.
We appreciate your understanding and look forward to continuing to serve you. If you have any questions, please contact us at support@company.com.

Best regards,
Customer Service Department`,
  koreanNouns: `Subject: Change in Business Hours
To: All Customers
From: Customer Service Department
Date: May 5, 2025

Dear Valued Customers,

We would like to inform you that our business hours will be adjusted starting next month to better serve our customers.

New Business Hours (<mark>적용</mark> June 1, 2025):
Monday – Friday: 9:00 AM – 7:00 PM (<mark>기존</mark> 8:00 AM – 6:00 PM)
Saturday: 10:00 AM – 5:00 PM (No change)
Sunday & Public Holidays: Closed

Important Notes:
- <mark>고객 서비스 담당자</mark> will be available during business hours only.
- Online support will remain available 24/7 through our website.
- Customers with pre-scheduled appointments outside the new business hours will be contacted <mark>개별적으로</mark>.

We appreciate your understanding and look forward to continuing to serve you. If you have any questions, please contact us at support@company.com.

Best regards,
Customer Service Department`,

  wordPairs: {
    Previously: "기존",
    Effective: "적용",
    "Customer service representatives": "고객 서비스 담당자",
    individually: "개별적으로",
  },

  questions: [],
};

const announcement2 = {
  id: 2,
  passage: `
To: All Employees and Building Tenants
From: Facility Management Office
Date: November 1, 2025

Dear Tenants and Employees,

We would like to inform you that scheduled maintenance work will be conducted at Midtown Office Tower to ensure the safety and functionality of the building.

Maintenance Schedule:
- Date: Saturday, November 9 – Sunday, November 10
- Time: 8:00 AM – 5:00 PM
- Affected Areas: Floors 10–15, Lobby, Parking Garage

Expected Impact:
- <mark>Power outages</mark> may occur <mark>intermittently</mark> during the maintenance period.
- Water supply will be temporarily shut off on affected floors.
- Elevator services may be limited or unavailable at <mark>certain</mark> times.

Important Notices:
- Employees working on the affected floors should save their work in advance to prevent data loss in case of power <mark>disruptions</mark>.
- Tenants are advised to use alternative parking spaces during the maintenance period.

If you experience any urgent issues, please contact building.support@midtown.com. We apologize for any inconvenience this may cause and appreciate your understanding as we complete these necessary improvements.

Best regards,
Facility Management Office`,

  translation: `
받는 사람: 모든 직원 및 건물 임차인
보내는 사람: 시설 관리실
날짜: 2025년 11월 1일

임차인 및 직원 여러분께,

미드타운 오피스 타워의 안전과 기능성을 보장하기 위해 예정된 유지보수 작업이 진행될 예정임을 알려드립니다.

유지보수 일정:

날짜: 11월 9일 토요일 – 11월 10일 일요일
시간: 오전 8:00 – 오후 5:00
영향 구역: 10-15층, 로비, 주차장

예상되는 영향:

유지보수 기간 동안 간헐적으로 정전이 발생할 수 있습니다.
해당 층의 수도 공급이 일시적으로 중단됩니다.
특정 시간대에 엘리베이터 서비스가 제한되거나 이용이 불가능할 수 있습니다.

중요 공지사항:

해당 층에서 근무하는 직원들은 정전으로 인한 데이터 손실을 방지하기 위해 미리 작업을 저장해 주시기 바랍니다.
임차인들은 유지보수 기간 동안 대체 주차 공간을 이용하시기 바랍니다.
긴급한 문제가 발생하면 building.support@midtown.com으로 연락해 주시기 바랍니다.

이로 인해 발생하는 불편에 대해 사과드리며, 필요한 개선 작업을 완료하는 동안 여러분의 이해에 감사드립니다.

Best regards,
Facility Management Office`,

  koreanNouns: `
To: All Employees and Building Tenants
From: Facility Management Office
Date: November 1, 2025

Dear Tenants and Employees,

We would like to inform you that scheduled maintenance work will be conducted at Midtown Office Tower to ensure the safety and functionality of the building.

Maintenance Schedule:
- Date: Saturday, November 9 – Sunday, November 10
- Time: 8:00 AM – 5:00 PM
- Affected Areas: Floors 10–15, Lobby, Parking Garage

Expected Impact:
- <mark>정전</mark> may occur <mark>간헐적으로</mark> during the maintenance period.
- Water supply will be temporarily shut off on affected floors.
- Elevator services may be limited or unavailable at <mark>특정</mark> times.

Important Notices:
- Employees working on the affected floors should save their work in advance to prevent data loss in case of power <mark>정전</mark>.
- Tenants are advised to use alternative parking spaces during the maintenance period.

If you experience any urgent issues, please contact building.support@midtown.com. We apologize for any inconvenience this may cause and appreciate your understanding as we complete these necessary improvements.

Best regards,
Facility Management Office`,

  wordPairs: {
    정전: "power outages",
    간헐적으로: "intermittently",
    특정: "certain",
    정전: "disruptions",
  },

  questions: [],
};

const announcement3 = {
  id: 3,
  passage: `To: All Library Patrons
From: Library Administration
Date: August 1, 2025

Dear Library Patrons,

Starting Monday, August 5, the Central Public Library will <mark>be implementing</mark> new access policies due to an increase in visitor numbers. 
To ensure a more efficient and comfortable experience for all users, the following <mark>adjustments</mark> will be made:

New Policy Changes:

1. <mark>Advance reservations</mark> will be required for study rooms. 
Walk-in access will no longer be permitted. Reservations can be made online through the library's website or at the information desk.

2. Computer usage in the research section will be limited to one hour per user per day to <mark>accommodate</mark> more visitors. 
Users who require additional time must request an extension from a librarian, which will <mark>be granted</mark> based on availability.

3. The library café will be relocated to the second floor due to ongoing renovations on the ground level. 
As a result, food and beverages will be temporarily <mark>prohibited</mark> in all study areas.

Additional Information:
These new policies will remain in effect until further notice.
For questions or concerns, please contact the library administration office at admin@citylibrary.org.

Thank you for your cooperation.

Best regards,
Library Administration`,

  translation: `받는 사람: 모든 도서관 이용자
보내는 사람: 도서관 행정실
날짜: 2025년 8월 1일

도서관 이용자 여러분께,

8월 5일 월요일부터 중앙도서관은 이용자 수 증가로 인해 새로운 출입 정책을 시행할 예정입니다. 모든 이용자의 더욱 효율적이고 편안한 이용을 위해 다음과 같은 조정이 이루어질 예정입니다:

새로운 정책 변경사항:

1. 스터디룸 이용 시 사전 예약이 필수가 됩니다. 현장 방문 이용은 더 이상 허용되지 않습니다. 예약은 도서관 웹사이트나 안내 데스크에서 하실 수 있습니다.

2. 더 많은 방문객을 수용하기 위해 연구실의 컴퓨터 사용 시간이 1인당 하루 1시간으로 제한됩니다. 추가 시간이 필요한 이용자는 사서에게 연장을 요청해야 하며, 이는 가용성에 따라 허가됩니다.

3. 1층 진행 중인 리모델링으로 인해 도서관 카페가 2층으로 이전됩니다. 이에 따라 모든 학습 공간에서 음식과 음료가 일시적으로 금지됩니다.

추가 정보:

이 새로운 정책들은 추후 공지가 있을 때까지 유지됩니다.
문의사항이나 우려사항이 있으시면 도서관 행정실(admin@citylibrary.org)로 연락 주시기 바랍니다.

협조해 주셔서 감사합니다.

감사합니다.
도서관 행정실`,

  koreanNouns: `To: All Library Patrons
From: Library Administration
Date: August 1, 2025

Dear Library Patrons,

Starting Monday, August 5, the Central Public Library will <mark>시행할 예정입니다</mark> new access policies due to an increase in visitor numbers. 
To ensure a more efficient and comfortable experience for all users, the following <mark>조정</mark> will be made:

New Policy Changes:

1. <mark>사전 예약</mark> will be required for study rooms. 
Walk-in access will no longer be permitted. Reservations can be made online through the library's website or at the information desk.

2. Computer usage in the research section will be limited to one hour per user per day to <mark>수용하다</mark> more visitors. 
Users who require additional time must request an extension from a librarian, which will <mark>허가됩니다</mark> based on availability.

3. The library café will be relocated to the second floor due to ongoing renovations on the ground level. 
As a result, food and beverages will be temporarily <mark>금지된다</mark> in all study areas.

Additional Information:
These new policies will remain in effect until further notice.
For questions or concerns, please contact the library administration office at admin@citylibrary.org.

Thank you for your cooperation.

Best regards,
Library Administration`,

  wordPairs: {
    adjustments: "조정",
    "Advance reservations": "사전 예약",
    accommodate: "수용하다",
    "be granted": "허가됩니다",
    prohibited: "금지된다",
  },

  questions: [],
};

const announcement4 = {
  id: 4,
  passage: `To: All Employees and Visitors
From: Building Safety Office
Date: December 18, 2025

Dear Employees and Visitors,

Due to heavy snowfall and freezing temperatures, surfaces around the building have become <mark>extremely</mark> <mark>slippery</mark>. 
Please exercise <mark>caution</mark> when entering and exiting the <mark>premises</mark>.

<mark>Hazard Areas</mark> Identified:
Parking lot and main entrance stairs
Sidewalks surrounding the building
Underground garage <mark>ramp</mark>

<mark>Safety Measures</mark>:
Maintenance staff will be applying salt and clearing snow <mark>throughout</mark> the day.
Employees are encouraged to wear <mark>slip-resistant</mark> footwear.
Handrails should be used when taking the stairs.

Reporting Hazards:
If you notice any <mark>particularly</mark> dangerous areas, please report them to safety@company.com or call (555) 321-6789.

Your safety is our top priority. Please take necessary precautions and stay alert.

Best regards,
Building Safety Office`,

  translation: `받는 사람: 모든 직원 및 방문객
보내는 사람: 건물 안전관리실
날짜: 2025년 12월 18일

직원 및 방문객 여러분께,

폭설과 영하의 기온으로 인해 건물 주변 표면이 매우 미끄러졌습니다. 건물 출입 시 각별한 주의를 기울여 주시기 바랍니다.

위험 구역 식별:

주차장 및 정문 계단
건물 주변 보도
지하 주차장 경사로

안전 조치:

관리 직원이 하루 종일 제설작업과 염화칼슘 살포를 실시할 예정입니다.
직원들은 미끄럼 방지 신발을 착용하시기 바랍니다.
계단 이용 시 반드시 난간을 잡고 이용하시기 바랍니다.

위험 요소 신고:
특별히 위험한 구역을 발견하시면 safety@company.com으로 이메일을 보내시거나 (555) 321-6789로 전화해 주시기 바랍니다.

여러분의 안전이 저희의 최우선 과제입니다. 필요한 예방 조치를 취하시고 주의를 기울여 주시기 바랍니다.

감사합니다.
건물 안전관리실`,

  koreanNouns: `To: All Employees and Visitors
From: Building Safety Office
Date: December 18, 2025

Dear Employees and Visitors,

Due to heavy snowfall and freezing temperatures, surfaces around the building have become <mark>매우</mark> <mark>미끄러운</mark>. 
Please exercise <mark>주의</mark> when entering and exiting the <mark>건물</mark>.

<mark>위험 구역</mark> Identified:
Parking lot and main entrance stairs
Sidewalks surrounding the building
Underground garage <mark>경사로</mark>

<mark>안전 조치</mark>:
Maintenance staff will be applying salt and clearing snow <mark>내내</mark> the day.
Employees are encouraged to wear <mark>미끄럼 방지</mark> footwear.
Handrails should be used when taking the stairs.

Reporting Hazards:
If you notice any <mark>특별히</mark> dangerous areas, please report them to safety@company.com or call (555) 321-6789.

Your safety is our top priority. Please take necessary precautions and stay alert.

Best regards,
Building Safety Office`,
  wordPairs: {
    slippery: "미끄러운",
    extremely: "매우",
    caution: "주의",
    premises: "건물",
    "Hazard Areas": "위험 구역",
    ramp: "경사로",
    "Safety Measures": "안전 조치",
    throughout: "내내",
    "slip-resistant": "미끄럼 방지",
    particularly: "특별히",
  },

  questions: [],
};

const announcement5 = {
  id: 5,
  passage: `To: All Employees
From: Human Resources Department
Date: September 5, 2025

Dear Team,

We are pleased to invite you to our upcoming Employee Development Workshop, designed to help employees enhance productivity and efficiency in the workplace. 
Attendance is <mark>mandatory</mark> for all staff members.

Workshop Details:
• Date: Friday, September 20, 2025
• Time: 10:00 AM – 3:00 PM
• Location: Main Conference Hall, 3rd Floor

Workshop Highlights:
• Effective time management techniques
• Strategies for improving team collaboration
• Best practices for handling work-related stress

Additional Information:
• A <mark>certificate</mark> of completion will be provided to all <mark>attendees</mark>.
• Lunch and refreshments will be served.
• Employees who are unable to attend must notify HR at hr@company.com by September 10.

We encourage all employees to actively participate and take advantage of this opportunity for professional growth.

Best regards,
HR Department`,

  translation: `받는 사람: 모든 직원
보내는 사람: 인사부
날짜: 2025년 9월 5일

팀원 여러분,

직장 내 생산성과 효율성을 향상시키기 위해 마련된 직원 개발 워크숍에 여러분을 초대하게 되어 기쁩니다. 모든 직원의 참석이 필수입니다.

워크숍 세부사항:

날짜: 2025년 9월 20일 금요일
시간: 오전 10:00 – 오후 3:00
장소: 본관 3층 대회의실

워크숍 주요 내용:
• 효과적인 시간 관리 기법
• 팀 협업 향상을 위한 전략
• 업무 관련 스트레스 관리를 위한 모범 사례

추가 정보:

모든 참석자에게 수료증이 제공됩니다.
점심식사와 다과가 제공됩니다.
참석이 불가능한 직원은 9월 10일까지 hr@company.com으로 인사부에 알려주시기 바랍니다.

모든 직원들이 적극적으로 참여하여 전문성 개발의 기회를 활용하시기를 권장합니다.

감사합니다.
인사부`,

  koreanNouns: `To: All Employees
From: Human Resources Department
Date: September 5, 2025

Dear Team,

We are pleased to invite you to our upcoming Employee Development Workshop, designed to help employees enhance productivity and efficiency in the workplace. 
Attendance is <mark>필수</mark> for all staff members.

Workshop Details:
• Date: Friday, September 20, 2025
• Time: 10:00 AM – 3:00 PM
• Location: Main Conference Hall, 3rd Floor

Workshop Highlights:
• Effective time management techniques
• Strategies for improving team collaboration
• Best practices for handling work-related stress

Additional Information:
• A <mark>수료증</mark> of completion will be provided to all <mark>참석자</mark>.
• Lunch and refreshments will be served.
• Employees who are unable to attend must notify HR at hr@company.com by September 10.

We encourage all employees to actively participate and take advantage of this opportunity for professional growth.

Best regards,
HR Department`,
  wordPairs: {
    mandatory: "필수",
    certificate: "수료증",
    attendees: "참석자",
  },

  questions: [],
};

const announcement6 = {
  id: 6,
  passage: `To: Local Residents and Business Owners
From: Springfield City Planning <mark>Committee</mark>
Date: March 15, 2025

Dear Residents and Business Owners,

The Springfield City Planning Committee invites you to a public meeting regarding upcoming city development projects. Your participation is essential in shaping the future of our community.

Meeting Details:
• Date: Tuesday, March 28, 2025
• Time: 6:30 PM – 8:30 PM
• Location: Springfield Community Center, Room 201

Topics to be Discussed:
• Proposed road expansion and infrastructure improvements
• Plans for new parks and <mark>recreational facilities</mark>
• Public feedback session on community concerns

Additional Information:
The meeting is open to all residents.
Written suggestions can be submitted in advance via planning@springfield.gov.
Meeting minutes will be published on www.springfield.gov.

We encourage you to attend and voice your opinions on these important city projects.

Best regards,
Springfield City Planning Committee`,

  translation: `받는 사람: 지역 주민 및 사업주
보내는 사람: 스프링필드 시 계획위원회
날짜: 2025년 3월 15일

주민 및 사업주 여러분께,

스프링필드 시 계획위원회는 예정된 도시 개발 프로젝트에 관한 공청회에 여러분을 초대합니다. 우리 지역사회의 미래를 형성하는 데 여러분의 참여가 필수적입니다.

회의 세부사항:

날짜: 2025년 3월 28일 화요일
시간: 오후 6:30 – 오후 8:30
장소: 스프링필드 커뮤니티 센터, 201호

논의 주제:
• 도로 확장 및 기반시설 개선 제안
• 새로운 공원 및 여가시설 계획
• 지역사회 현안에 대한 주민 의견 수렴

추가 정보:

모든 주민에게 개방된 회의입니다.
서면 제안은 planning@springfield.gov를 통해 사전 제출이 가능합니다.
회의록은 www.springfield.gov에 게시될 예정입니다.

이러한 중요한 도시 프로젝트에 대해 참석하시어 의견을 개진해 주시기를 권장합니다.

감사합니다.
스프링필드 시 계획위원회`,
  koreanNouns: `To: Local Residents and Business Owners
From: Springfield City Planning <mark>계획위원회</mark>
Date: March 15, 2025

Dear Residents and Business Owners,

The Springfield City Planning Committee invites you to a public meeting regarding upcoming city development projects. Your participation is essential in shaping the future of our community.

Meeting Details:
• Date: Tuesday, March 28, 2025
• Time: 6:30 PM – 8:30 PM
• Location: Springfield Community Center, Room 201

Topics to be Discussed:
• Proposed road expansion and infrastructure improvements
• Plans for new parks and <mark>여가시설</mark>
• Public feedback session on community concerns

Additional Information:
The meeting is open to all residents.
Written suggestions can be submitted in advance via planning@springfield.gov.
Meeting minutes will be published on www.springfield.gov.

We encourage you to attend and voice your opinions on these important city projects.

Best regards,
Springfield City Planning Committee`,
  wordPairs: {
    Committee: "계획위원회",
    "recreational facilities": "여가시설",
  },

  questions: [],
};

const announcement7 = {
  id: 7,
  passage: `To: All Business Professionals and Industry Leaders
From: Global Business Association
Date: June 10, 2025

Dear Professionals,

We are excited to invite you to the 2025 Business Networking Conference, an exclusive opportunity to connect with industry leaders, <mark>entrepreneurs</mark>, and professionals from various fields.

Event Details:
• Date: Thursday, July 18, 2025
• Time: 9:00 AM – 5:00 PM
• Location: Grand Convention Center, Downtown New York

Event Highlights:
• Keynote speeches by industry <mark>experts</mark>
• Panel discussions on <mark>emerging</mark> market trends
• One-on-one networking sessions with business leaders

Registration Details:
• Early registration discount available until June 30, 2025.
• Limited seats available – register now at www.biznetwork2025.com.

Don't miss this opportunity to expand your professional network and gain valuable insights from top <mark>executives</mark>.

Best regards,
Global Business Association`,

  translation: `받는 사람: 모든 비즈니스 전문가 및 산업계 리더
보내는 사람: 글로벌 비즈니스 협회
날짜: 2025년 6월 10일

전문가 여러분,

2025 비즈니스 네트워킹 컨퍼런스에 여러분을 초대하게 되어 기쁩니다. 이는 산업계 리더, 기업가, 그리고 다양한 분야의 전문가들과 교류할 수 있는 특별한 기회입니다.

행사 세부사항:

날짜: 2025년 7월 18일 목요일
시간: 오전 9:00 – 오후 5:00
장소: 그랜드 컨벤션 센터, 뉴욕 다운타운

행사 주요 내용:
• 업계 전문가들의 기조연설
• 신흥 시장 동향에 대한 패널 토론
• 비즈니스 리더들과의 일대일 네트워킹 세션

등록 세부사항:

2025년 6월 30일까지 조기 등록 할인이 가능합니다.
좌석이 한정되어 있습니다 – 지금 www.biznetwork2025.com에서 등록하세요.

전문가 네트워크를 확장하고 최고 경영진들로부터 귀중한 통찰력을 얻을 수 있는 이 기회를 놓치지 마세요.

감사합니다.
글로벌 비즈니스 협회`,

  koreanNouns: `To: All Business Professionals and Industry Leaders
From: Global Business Association
Date: June 10, 2025

Dear Professionals,

We are excited to invite you to the 2025 Business Networking Conference, an exclusive opportunity to connect with industry leaders, <mark>기업가</mark>, and professionals from various fields.

Event Details:
• Date: Thursday, July 18, 2025
• Time: 9:00 AM – 5:00 PM
• Location: Grand Convention Center, Downtown New York

Event Highlights:
• Keynote speeches by industry <mark>전문가</mark>
• Panel discussions on <mark>신흥</mark> market trends
• One-on-one networking sessions with business leaders

Registration Details:
• Early registration discount available until June 30, 2025.
• Limited seats available – register now at www.biznetwork2025.com.

Don't miss this opportunity to expand your professional network and gain valuable insights from top <mark>경영진</mark>.

Best regards,
Global Business Association`,

  wordPairs: {
    experts: "전문가",
    emerging: "신흥",
    executives: "경영진",
    entrepreneurs: "기업가",
  },

  questions: [],
};

const announcement8 = {
  id: 8,
  passage: `To: All Employees
From: Facilities Management Team
Date: June 15, 2025

Dear Employees,

Due to the increasing number of employees commuting to the office, our company parking policy will <mark>be revised</mark> starting Monday, July 1. Please review the following updates carefully:

Parking Policy Updates:

1. <mark>Parking permits</mark> will be required for all employees. Those who have not yet applied for a permit must do so by June 25 at the reception desk. Employees without a <mark>valid</mark> permit will not be allowed to park on-site.

2. <mark>Designated parking zones</mark> will be assigned based on <mark>employee seniority</mark>. Managers and senior staff will have access to Lot A, while general employees will <mark>be allocated to</mark> Lot B and Lot C.

3. A new carpool incentive program will be introduced. Employees who register for carpooling will receive priority parking spaces and a monthly transportation <mark>subsidy</mark>. Details on how to <mark>enroll</mark> will be provided via email next week.

4. Visitor parking will now require prior approval. Employees who expect guests must submit a parking request form at least 24 hours in advance.

These changes are being implemented to improve traffic flow and maximize parking availability. If you have any questions, please contact the Facilities Management Team at parking@company.com.

Best regards,
Facilities Management Team`,

  translation: `받는 사람: 모든 직원
보내는 사람: 시설관리팀
날짜: 2025년 6월 15일

직원 여러분,

사무실로 출퇴근하는 직원이 증가함에 따라 7월 1일 월요일부터 회사 주차 정책이 개정될 예정입니다. 다음 변경사항을 주의 깊게 검토해 주시기 바랍니다:

주차 정책 변경사항:

1. 모든 직원에게 주차 허가증이 필요합니다. 아직 허가증을 신청하지 않은 직원은 6월 25일까지 접수처에서 신청해야 합니다. 유효한 허가증이 없는 직원은 현장 주차가 불가능합니다.

2. 지정 주차구역은 직원의 근속 연수에 따라 배정됩니다. 관리자와 선임 직원은 A구역을 이용할 수 있으며, 일반 직원은 B구역과 C구역에 배정됩니다.

3. 새로운 카풀 인센티브 프로그램이 도입됩니다. 카풀에 등록한 직원은 우선 주차 공간과 월간 교통 보조금을 받게 됩니다. 등록 방법에 대한 자세한 내용은 다음 주에 이메일로 안내될 예정입니다.

4. 방문객 주차는 이제 사전 승인이 필요합니다. 방문객이 예정된 직원은 최소 24시간 전에 주차 신청서를 제출해야 합니다.

이러한 변경사항은 교통 흐름을 개선하고 주차 가용성을 최대화하기 위해 시행됩니다. 문의사항이 있으시면 parking@company.com으로 시설관리팀에 연락해 주시기 바랍니다.

감사합니다.
시설관리팀`,

  koreanNouns: `To: All Employees
From: Facilities Management Team
Date: June 15, 2025

Dear Employees,

Due to the increasing number of employees commuting to the office, our company parking policy will <mark>개정되다</mark> starting Monday, July 1. Please review the following updates carefully:

Parking Policy Updates:

1. <mark>주차 허가증</mark> will be required for all employees. Those who have not yet applied for a permit must do so by June 25 at the reception desk. Employees without a <mark>유효한</mark> permit will not be allowed to park on-site.

2. <mark>지정 주차구역</mark> will be assigned based on <mark>직원 근속 연수</mark>. Managers and senior staff will have access to Lot A, while general employees will <mark>배정되다</mark> Lot B and Lot C.

3. A new carpool incentive program will be introduced. Employees who register for carpooling will receive priority parking spaces and a monthly transportation <mark>보조금</mark>. Details on how to <mark>등록</mark> will be provided via email next week.

4. Visitor parking will now require prior approval. Employees who expect guests must submit a parking request form at least 24 hours in advance.

These changes are being implemented to improve traffic flow and maximize parking availability. If you have any questions, please contact the Facilities Management Team at parking@company.com.

Best regards,
Facilities Management Team`,

  wordPairs: {
    "be revised": "개정되다",
    "Parking permits": "주차 허가증",
    valid: "유효한",
    "employee seniority": "직원 근속 연수",
    "Designated parking zones": "지정 주차구역",
    "be allocated to": "배정되다",
    subsidy: "보조금",
    enroll: "등록",
  },

  questions: [],
};

const announcement9 = {
  id: 9,
  passage: `To: All Customers
From: First National Bank
Date: October 15, 2025

Dear Customers,

Starting October 15, 2025, we will be implementing updates to our banking <mark>transaction</mark> policies to enhance security and customer convenience. Please review the following changes carefully:

1. Daily <mark>withdrawal</mark> limits: The maximum daily ATM <mark>withdrawal</mark> limit will be adjusted from $1,000 to $800 for standard accounts. Premium <mark>account holders</mark> will retain their existing <mark>withdrawal</mark> limits.

2. Overseas transactions: Customers traveling abroad will now be required to activate international transactions through our online banking system before making purchases or withdrawing cash outside the country.

3. Check <mark>deposit</mark> processing time: <mark>Deposit</mark>s made after 5:00 PM on business days will be processed on the next banking day. <mark>Deposit</mark>s made on weekends and public holidays will be processed on the next available business day.

These updates are intended to improve the security and efficiency of our banking services. If you have any questions, please contact our Customer Support Center at (800) 555-2025 or visit www.firstnationalbank.com.

Thank you for banking with us.`,

  translation: `받는 사람: 모든 고객
보내는 사람: 퍼스트 내셔널 은행
날짜: 2025년 10월 15일

고객 여러분,

2025년 10월 15일부터 보안 강화와 고객 편의를 위해 은행 거래 정책이 업데이트될 예정입니다. 다음의 변경사항을 주의 깊게 검토해 주시기 바랍니다:

1. 일일 인출 한도: 일반 계좌의 최대 일일 ATM 인출 한도가 $1,000에서 $800로 조정됩니다. 프리미엄 계좌 보유자는 기존 인출 한도를 유지합니다.

2. 해외 거래: 해외 여행 중인 고객은 국외에서 구매나 현금 인출을 하기 전에 온라인 뱅킹 시스템을 통해 국제 거래를 활성화해야 합니다.

3. 수표 입금 처리 시간: 영업일 오후 5시 이후 입금은 다음 영업일에 처리됩니다. 주말과 공휴일의 입금은 다음 영업일에 처리됩니다.

이러한 업데이트는 은행 서비스의 보안과 효율성을 개선하기 위한 것입니다. 문의사항이 있으시면 고객 지원 센터 (800) 555-2025로 연락하시거나 www.firstnationalbank.com을 방문해 주시기 바랍니다.

저희 은행을 이용해 주셔서 감사합니다.`,
  koreanNouns: `To: All Customers
From: First National Bank
Date: October 15, 2025

Dear Customers,

Starting October 15, 2025, we will be implementing updates to our banking <mark>거래</mark> policies to enhance security and customer convenience. Please review the following changes carefully:

1. Daily <mark>인출</mark> limits: The maximum daily ATM <mark>인출</mark> limit will be adjusted from $1,000 to $800 for standard accounts. Premium <mark>계좌 보유자</mark> will retain their existing <mark>인출</mark> limits.

2. Overseas transactions: Customers traveling abroad will now be required to activate international transactions through our online banking system before making purchases or withdrawing cash outside the country.

3. Check <mark>입금</mark> processing time: <mark>입금</mark>s made after 5:00 PM on business days will be processed on the next banking day. <mark>입금</mark>s made on weekends and public holidays will be processed on the next available business day.

These updates are intended to improve the security and efficiency of our banking services. If you have any questions, please contact our Customer Support Center at (800) 555-2025 or visit www.firstnationalbank.com.

Thank you for banking with us.`,

  wordPairs: {
    transaction: "거래",
    withdrawal: "인출",
    "account holders": "계좌 보유자",
    deposit: "입금",
  },

  questions: [],
};

const announcement10 = {
  id: 10,
  passage: `To: All Employees
From: Human Resources Department
Date: March 1, 2025

Dear Team,

We are pleased to announce that a new Flexible Work Policy will be implemented starting April 1, 2025, to enhance employee work-life balance.

Key Changes:
• Employees may now work <mark>remotely</mark> up to two days per week.
• Flexible work hours are available between 7:00 AM and 10:00 AM (start time).
• Requests for remote work must be submitted at least 24 hours in advance.

Important Information:
• This policy applies to all <mark>full-time employees</mark>.
• Department managers must approve remote work schedules to ensure operational efficiency.
• Employees must remain accessible during business hours while working <mark>remotely</mark>.

For further details, please review the updated policy document on the company intranet or contact hr@company.com.

Best regards,
Human Resources Department`,

  translation: `받는 사람: 모든 직원
보내는 사람: 인사부
날짜: 2025년 3월 1일

팀원 여러분,

2025년 4월 1일부터 직원들의 일과 삶의 균형을 향상시키기 위한 새로운 유연근무제가 시행될 예정임을 알려드리게 되어 기쁩니다.

주요 변경사항:
• 직원들은 이제 주당 최대 2일까지 원격근무가 가능합니다.
• 유연근무시간은 오전 7시부터 오전 10시 사이입니다(출근시간 기준).
• 원격근무 신청은 최소 24시간 전에 제출해야 합니다.

중요 정보:

이 정책은 모든 정규직 직원들에게 적용됩니다.
부서 관리자들은 업무 효율성을 위해 원격근무 일정을 승인해야 합니다.
원격근무 중인 직원들은 업무시간 동안 연락이 가능해야 합니다.

자세한 내용은 회사 인트라넷의 업데이트된 정책 문서를 검토하시거나 hr@company.com으로 문의해 주시기 바랍니다.

감사합니다.
인사부`,

  koreanNouns: `To: All Employees
From: Human Resources Department
Date: March 1, 2025

Dear Team,

We are pleased to announce that a new Flexible Work Policy will be implemented starting April 1, 2025, to enhance employee work-life balance.

Key Changes:
• Employees may now work <mark>원격근무</mark> up to two days per week.
• Flexible work hours are available between 7:00 AM and 10:00 AM (start time).
• Requests for remote work must be submitted at least 24 hours in advance.

Important Information:
• This policy applies to all <mark>정규직 직원들</mark>.
• Department managers must approve remote work schedules to ensure operational efficiency.
• Employees must remain accessible during business hours while working <mark>원격근무</mark>.

For further details, please review the updated policy document on the company intranet or contact hr@company.com.

Best regards,
Human Resources Department`,

  wordPairs: {
    remotely: "원격근무",
    "full-time employees": "정규직 직원들",
  },

  questions: [],
};

const announcement11 = {
  id: 11,
  passage: `To: All Employees
From: Facility Management Office  
Date: September 1, 2025

Subject: New Security Badge Access Policy – Effective September 15

To enhance workplace security, a new badge access policy will take effect starting September 15, 2025. Please carefully review the updated guidelines below:

Badge Requirement: Employees must use their company-issued ID badges to enter all office buildings. Temporary badges will no longer be available at the reception desk. If you forget your badge, you must request a one-day access code from the security office.

Restricted Areas: Certain zones, such as server rooms and <mark>executive</mark> offices, will require additional <mark>authorization</mark>. Employees needing access must submit a <mark>written request</mark> to the Facilities Management Office at least 48 hours in advance.

Visitor Access: All visitors must be pre-registered online before their arrival. Hosts are responsible for meeting their guests at the entrance and escorting them during their visit.

Badge Replacement: Lost or damaged ID badges must be reported immediately. Replacements can be requested via HR Services, and a $20 fee will apply for issuing a new badge.

Failure to <mark>comply with</mark> these policies may result in restricted access or <mark>disciplinary action</mark>. If you have any questions, please contact the Facilities Management Office at security@company.com.

Thank you for your cooperation.`,

  translation: `받는 사람: 전 직원
보내는 사람: 시설관리실
날짜: 2025년 9월 1일

제목: 새로운 보안 출입증 정책 – 9월 15일부터 시행

직장 보안 강화를 위해 9월 15일부터 새로운 출입증 정책이 시행될 예정입니다. 아래의 업데이트된 지침을 주의 깊게 검토해 주시기 바랍니다:

출입증 요구사항: 직원들은 모든 사무실 건물 출입 시 회사에서 발급한 ID 출입증을 사용해야 합니다. 안내데스크에서 더 이상 임시 출입증이 발급되지 않습니다. 출입증을 잊어버린 경우, 보안실에서 1일 출입 코드를 요청해야 합니다.

제한구역: 서버실과 임원실과 같은 특정 구역은 추가 승인이 필요합니다. 출입이 필요한 직원은 최소 48시간 전에 시설관리실에 서면 요청서를 제출해야 합니다.

방문객 출입: 모든 방문객은 도착 전 온라인으로 사전 등록되어야 합니다. 초대자는 방문객을 입구에서 맞이하고 방문 기간 동안 동행해야 할 책임이 있습니다.

출입증 재발급: 분실하거나 손상된 ID 출입증은 즉시 신고해야 합니다. 재발급은 인사서비스를 통해 요청할 수 있으며, 새 출입증 발급 시 20달러의 수수료가 부과됩니다.

이러한 정책을 준수하지 않을 경우 출입 제한이나 징계 조치를 받을 수 있습니다. 문의사항이 있으시면 security@company.com으로 시설관리실에 연락 주시기 바랍니다.

협조해 주셔서 감사합니다.`,

  koreanNouns: `To: All Employees
From: Facility Management Office  
Date: September 1, 2025

Subject: New Security Badge Access Policy – Effective September 15

To enhance workplace security, a new badge access policy will take effect starting September 15, 2025. Please carefully review the updated guidelines below:

Badge Requirement: Employees must use their company-issued ID badges to enter all office buildings. Temporary badges will no longer be available at the reception desk. If you forget your badge, you must request a one-day access code from the security office.

Restricted Areas: Certain zones, such as server rooms and <mark>임원</mark> offices, will require additional <mark>승인</mark>. Employees needing access must submit a <mark>서면 요청서</mark> to the Facilities Management Office at least 48 hours in advance.

Visitor Access: All visitors must be pre-registered online before their arrival. Hosts are responsible for meeting their guests at the entrance and escorting them during their visit.

Badge Replacement: Lost or damaged ID badges must be reported immediately. Replacements can be requested via HR Services, and a $20 fee will apply for issuing a new badge.

Failure to <mark>준수하다</mark> these policies may result in restricted access or <mark>징계 조치</mark>. If you have any questions, please contact the Facilities Management Office at security@company.com.

Thank you for your cooperation.`,

  wordPairs: {
    executive: "임원",
    authorization: "승인",
    "written request": "서면 요청서",
    "comply with": "준수하다",
    "disciplinary action": "징계 조치",
  },

  questions: [],
};

const announcement12 = {
  id: 12,
  passage: `To: All Job Seekers
From: Human Resources Department
Date: March 5, 2025

Dear Candidates,

We are pleased to announce an exciting opportunity to join our team. We are currently seeking a highly motivated Marketing Coordinator to support our growing business.

Position Details:

Job Title: Marketing Coordinator
• Department: Marketing & Communications
• Location: Downtown Office, Chicago, IL
• Employment Type: Full-time

Key Responsibilities:
• Develop and execute marketing campaigns
• Assist in social media strategy and content creation
• Conduct market research and competitor analysis

Qualifications:
• <mark>Bachelor's degree</mark> in Marketing, Communications, or a related field
• At least 2 years of experience in a marketing role
• Strong written and <mark>verbal</mark> communication skills

Application Process:
Interested <mark>applicants</mark> should submit their resume and cover letter by March 25, 2025, via careers@company.com.
<mark>Shortlisted</mark> <mark>candidates</mark> will be contacted for an interview.

We look forward to welcoming a talented professional to our team!

Best regards,
Human Resources Department`,

  translation: `받는 사람: 모든 구직자
보내는 사람: 인사부
날짜: 2025년 3월 5일

지원자 여러분,

저희 팀에 합류할 수 있는 좋은 기회를 알려드리게 되어 기쁩니다. 현재 성장하는 비즈니스를 지원할 열정적인 마케팅 코디네이터를 찾고 있습니다.

직책 세부사항:

직책명: 마케팅 코디네이터
부서: 마케팅 & 커뮤니케이션
근무지: 시카고 다운타운 사무실, 일리노이
고용형태: 정규직

주요 업무:
• 마케팅 캠페인 개발 및 실행
• 소셜 미디어 전략 및 콘텐츠 제작 지원
• 시장 조사 및 경쟁사 분석 수행

자격요건:

마케팅, 커뮤니케이션 또는 관련 분야 학사학위
마케팅 분야 최소 2년 이상 경력
우수한 문서 작성 및 구두 의사소통 능력

지원 절차:

관심 있는 지원자는 2025년 3월 25일까지 이력서와 자기소개서를 careers@company.com으로 제출해 주시기 바랍니다.
서류 심사 통과자에 한해 면접 연락을 드릴 예정입니다.

실력 있는 전문가를 저희 팀에 모시기를 기대합니다!

감사합니다.
인사부`,

  koreanNouns: `To: All Job Seekers
From: Human Resources Department
Date: March 5, 2025

Dear Candidates,

We are pleased to announce an exciting opportunity to join our team. We are currently seeking a highly motivated Marketing Coordinator to support our growing business.

Position Details:

Job Title: Marketing Coordinator
• Department: Marketing & Communications
• Location: Downtown Office, Chicago, IL
• Employment Type: Full-time

Key Responsibilities:
• Develop and execute marketing campaigns
• Assist in social media strategy and content creation
• Conduct market research and competitor analysis

Qualifications:
• <mark>학사학위</mark> in Marketing, Communications, or a related field
• At least 2 years of experience in a marketing role
• Strong written and <mark>구두의</mark> communication skills

Application Process:
Interested <mark>지원자들</mark> should submit their resume and cover letter by March 25, 2025, via careers@company.com.
<mark>서류 심사 통과된</mark> <mark>지원자들</mark> will be contacted for an interview.

We look forward to welcoming a talented professional to our team!

Best regards,
Human Resources Department`,
  wordPairs: {
    "Bachelor's degree": "학사학위",
    verbal: "구두의",
    applicants: "지원자들",
    Shortlisted: "서류 심사 통과된",
    candidates: "지원자들",
  },

  questions: [],
};

const announcement13 = {
  id: 13,
  passage: `To: University Students & Recent Graduates
From: HR Internship Program Team
Date: May 1, 2025

Dear Students,

We are excited to offer a Summer Internship Program for motivated <mark>individuals</mark> seeking hands-on experience in a professional environment.

Internship Details:
• Duration: June 15 – August 30, 2025
• Departments: Marketing, IT, Finance, and Human Resources
• Location: <mark>Headquarters</mark>, New York City

What You Will Gain:
• Real-world experience in your chosen field
• Mentorship from industry professionals
• Networking opportunities with company executives

Eligibility Requirements:
• Must be a junior or senior in college or a <mark>recent graduate</mark>
• Strong analytical and problem-solving skills
• Ability to work independently and as part of a team

How to Apply:
Submit your resume and a brief <mark>personal statement</mark> at internships@company.com by May 20, 2025.
Successful applicants will be contacted for an initial interview.

Kick-start your career with us this summer!

Best regards,
HR Internship Program Team`,

  translation: `받는 사람: 대학생 및 최근 졸업생
보내는 사람: 인사부 인턴십 프로그램 팀
날짜: 2025년 5월 1일

학생 여러분,

전문적인 환경에서 실무 경험을 찾는 의욕적인 분들을 위한 여름 인턴십 프로그램을 제공하게 되어 기쁩니다.

인턴십 세부사항:

기간: 2025년 6월 15일 – 8월 30일
부서: 마케팅, IT, 재무, 인사
근무지: 뉴욕시 본사

얻게 될 것:
• 선택한 분야의 실무 경험
• 업계 전문가의 멘토링
• 회사 임원진과의 네트워킹 기회

지원 자격:

대학교 3,4학년생 또는 최근 졸업생
뛰어난 분석력과 문제 해결 능력
독립적으로 그리고 팀의 일원으로 일할 수 있는 능력

지원 방법:

2025년 5월 20일까지 이력서와 간단한 자기소개서를 internships@company.com으로 제출해 주세요.
서류 합격자에 한해 1차 면접 연락을 드립니다.

이번 여름, 저희와 함께 경력을 시작하세요!

감사합니다.
인사부 인턴십 프로그램 팀`,

  koreanNouns: `To: University Students & Recent Graduates
From: HR Internship Program Team
Date: May 1, 2025

Dear Students,

We are excited to offer a Summer Internship Program for motivated <mark>~하는 사람들</mark> seeking hands-on experience in a professional environment.

Internship Details:
• Duration: June 15 – August 30, 2025
• Departments: Marketing, IT, Finance, and Human Resources
• Location: <mark>본사</mark>, New York City

What You Will Gain:
• Real-world experience in your chosen field
• Mentorship from industry professionals
• Networking opportunities with company executives

Eligibility Requirements:
• Must be a junior or senior in college or a <mark>최근 졸업생</mark>
• Strong analytical and problem-solving skills
• Ability to work independently and as part of a team

How to Apply:
Submit your resume and a brief <mark>자기소개서</mark> at internships@company.com by May 20, 2025.
Successful applicants will be contacted for an initial interview.

Kick-start your career with us this summer!

Best regards,
HR Internship Program Team`,
  wordPairs: {
    individuals: "~하는 사람들",
    Headquarters: "본사",
    "recent graduate": "최근 졸업생",
    "personal statement": "자기소개서",
  },

  questions: [],
};

const announcement14 = {
  id: 14,
  passage: `To: Museum Visitors
From: City Museum Administration
Date: June 10, 2025

Subject: Temporary Exhibit Hall Closures & Renovation Schedule

We would like to inform visitors that several exhibit halls will be temporarily closed due to scheduled renovations. The following updates will take effect starting June 15, 2025:

History Wing – Closed from June 15 to July 5 for lighting and display upgrades.

Science & Innovation Hall – <mark>Partially</mark> open; certain sections will be <mark>inaccessible</mark> while new interactive exhibits are installed. The full reopening is expected on July 20.

Modern Art Gallery – Temporarily relocated to the East Pavilion for ongoing renovations. Visitors can access <mark>featured</mark> collections there until work is completed in August.

Guided Tours & Events – Some scheduled guided tours will be modified or relocated. Visitors with tour reservations will be notified of any changes via email at least 48 hours in advance.

We apologize for any inconvenience and appreciate your patience as we enhance our exhibits. For further inquiries, please visit www.citymuseumupdates.com or contact our Visitor Information Desk at (800) 555-6789.`,

  translation: `받는 사람: 박물관 방문객
보내는 사람: 시립박물관 관리부
날짜: 2025년 6월 10일

제목: 전시실 임시 폐쇄 및 리노베이션 일정

예정된 리노베이션으로 인해 몇몇 전시실이 임시 폐쇄될 예정임을 알려드립니다. 다음 변경사항은 2025년 6월 15일부터 적용됩니다:

역사관 – 조명 및 전시 업그레이드를 위해 6월 15일부터 7월 5일까지 폐쇄.

과학혁신관 – 부분 개방; 새로운 체험형 전시물 설치 중 일부 구역 출입 제한. 7월 20일 전면 재개장 예정.

현대미술관 – 진행 중인 리노베이션으로 인해 동쪽 파빌리온으로 임시 이전. 공사 완료되는 8월까지 해당 장소에서 주요 컬렉션 관람 가능.

가이드 투어 및 행사 – 일부 예정된 가이드 투어는 변경 또는 장소 이전될 수 있음. 투어 예약자는 변경사항 발생 시 최소 48시간 전에 이메일로 통보 받을 예정.

불편을 끼쳐 죄송합니다. 전시 개선을 위한 여러분의 양해에 감사드립니다. 추가 문의사항은 www.citymuseumupdates.com을 방문하시거나 방문자 안내데스크 (800) 555-6789로 연락 주시기 바랍니다.`,
  koreanNouns: `To: Museum Visitors
From: City Museum Administration
Date: June 10, 2025

Subject: Temporary Exhibit Hall Closures & Renovation Schedule

We would like to inform visitors that several exhibit halls will be temporarily closed due to scheduled renovations. The following updates will take effect starting June 15, 2025:

History Wing – Closed from June 15 to July 5 for lighting and display upgrades.

Science & Innovation Hall – <mark>부분적으로</mark> open; certain sections will be <mark>접근이 안되는</mark> while new interactive exhibits are installed. The full reopening is expected on July 20.

Modern Art Gallery – Temporarily relocated to the East Pavilion for ongoing renovations. Visitors can access <mark>주요한</mark> collections there until work is completed in August.

Guided Tours & Events – Some scheduled guided tours will be modified or relocated. Visitors with tour reservations will be notified of any changes via email at least 48 hours in advance.

We apologize for any inconvenience and appreciate your patience as we enhance our exhibits. For further inquiries, please visit www.citymuseumupdates.com or contact our Visitor Information Desk at (800) 555-6789.`,
  wordPairs: {
    inaccessible: "접근이 안되는",
    featured: "주요한",
    Partially: "부분적으로",
  },

  questions: [],
};

const announcement15 = {
  id: 15,
  passage: `To: All Library <mark>Patrons</mark>
From: Mooringtown Public Library Administration
Date: February 1, 2025

Dear Library Visitors,

We would like to inform you that our library usage policies have been updated to improve the experience for all patrons. These changes will take effect starting March 1, 2025.

Key Policy Updates:
• Extended borrowing period – Books can now be borrowed for up to 21 days instead of 14.
• New study room reservation system – Reservations must be made at least 24 hours in advance via our website.
• Food and beverage restrictions – Only <mark>sealed</mark> water bottles are allowed inside the reading areas.

Additional Information:
• Overdue books will now incur a late fee of $0.50 per day.
• Patrons must <mark>present</mark> a valid library card to access study rooms.
• For more details, please visit www.mooringtownlibrary.com.

We appreciate your cooperation in maintaining a quiet and welcoming environment.

Best regards,
Mooringtown Public Library Administration`,

  translation: `받는 사람: 모든 도서관 이용자
보내는 사람: 무어링타운 공공도서관 관리부
날짜: 2025년 2월 1일

도서관 방문자 여러분,

모든 이용자의 경험을 개선하기 위해 도서관 이용 정책이 업데이트되었음을 알려드립니다. 이러한 변경사항은 2025년 3월 1일부터 적용됩니다.

주요 정책 업데이트:
• 대출 기간 연장 – 이제 책을 14일이 아닌 최대 21일까지 대출할 수 있습니다.
• 새로운 학습실 예약 시스템 – 예약은 웹사이트를 통해 최소 24시간 전에 해야 합니다.
• 음식 및 음료 제한 – 열람실 내에는 밀봉된 생수만 허용됩니다.

추가 정보:

연체된 도서는 이제 하루당 0.50달러의 연체료가 부과됩니다.
학습실 이용을 위해서는 유효한 도서관 카드를 제시해야 합니다.
자세한 내용은 www.mooringtownlibrary.com을 방문해 주세요.

조용하고 쾌적한 환경 유지를 위한 여러분의 협조에 감사드립니다.

감사합니다.
무어링타운 공공도서관 관리부`,
  koreanNouns: `To: All Library <mark>이용자</mark>
From: Mooringtown Public Library Administration
Date: February 1, 2025

Dear Library Visitors,

We would like to inform you that our library usage policies have been updated to improve the experience for all patrons. These changes will take effect starting March 1, 2025.

Key Policy Updates:
• Extended borrowing period – Books can now be borrowed for up to 21 days instead of 14.
• New study room reservation system – Reservations must be made at least 24 hours in advance via our website.
• Food and beverage restrictions – Only <mark>밀봉된</mark> water bottles are allowed inside the reading areas.

Additional Information:
• Overdue books will now incur a late fee of $0.50 per day.
• Patrons must <mark>제시하다</mark> a valid library card to access study rooms.
• For more details, please visit www.mooringtownlibrary.com.

We appreciate your cooperation in maintaining a quiet and welcoming environment.

Best regards,
Mooringtown Public Library Administration`,

  wordPairs: {
    patrons: "이용자",
    sealed: "밀봉된",
    present: "제시하다",
  },

  questions: [],
};

const announcement16 = {
  id: 6,
  passage: `ATTENTION COMMUTERS

Currently, service on the Blue Line is experiencing delays due to increased passenger traffic from the <mark>downtown</mark> festival near Lincoln Square Station.

Our staff is actively managing crowd control to ensure smooth operations. Until the festival concludes, all trains will be operating at reduced speeds and may experience <mark>slight</mark> delays between Lincoln Square and Jefferson Avenue Stations.

For real-time updates on train schedules and delays, please visit www.metroupdates.com or download our transit notification app, Metro Alert.`,

  translation: `지하철 이용객 여러분께 안내드립니다

현재 블루 라인은 링컨 스퀘어역 인근 다운타운 축제로 인한 승객 증가로 지연이 발생하고 있습니다.

저희 직원들이 원활한 운영을 위해 적극적으로 군중 통제를 관리하고 있습니다. 축제가 종료될 때까지 모든 열차는 감속 운행되며 링컨 스퀘어역과 제퍼슨 애비뉴역 사이에서 약간의 지연이 발생할 수 있습니다.

열차 시간표와 지연에 대한 실시간 업데이트는 www.metroupdates.com을 방문하시거나 저희 교통 알림 앱인 Metro Alert를 다운로드하여 확인하실 수 있습니다.`,

  koreanNouns: `ATTENTION COMMUTERS

Currently, service on the Blue Line is experiencing delays due to increased passenger traffic from the <mark>도심</mark> festival near Lincoln Square Station.

Our staff is actively managing crowd control to ensure smooth operations. Until the festival concludes, all trains will be operating at reduced speeds and may experience <mark>약간의</mark> delays between Lincoln Square and Jefferson Avenue Stations.

For real-time updates on train schedules and delays, please visit www.metroupdates.com or download our transit notification app, Metro Alert.`,
  wordPairs: {
    downtown: "도심",
    slight: "약간의",
  },

  questions: [],
};
const announcement17 = {
  id: 17,
  passage: `SERVICE DISRUPTION NOTICE

Currently, train service on the Blue Line is experiencing delays due to an ongoing labor <mark>strike</mark> affecting station staff and maintenance <mark>crews</mark>.

Efforts are being made to resolve the situation as soon as possible. Until normal service resumes, trains will be running on a reduced schedule, and wait times may be longer than usual between Lincoln Square and Jefferson Avenue Stations.

For the latest updates on service changes and schedules, please visit www.metroupdates.com or download our transit notification app, Metro Alert.`,

  translation: `서비스 중단 안내

현재 블루 라인 열차 서비스는 역사 직원과 유지보수 인력에 영향을 미치는 진행 중인 노동 파업으로 인해 지연이 발생하고 있습니다.

상황을 최대한 빨리 해결하기 위해 노력하고 있습니다. 정상 운행이 재개될 때까지 열차는 축소된 일정으로 운행되며, 링컨 스퀘어역과 제퍼슨 애비뉴역 사이의 대기 시간이 평소보다 길어질 수 있습니다.

서비스 변경 및 일정에 대한 최신 업데이트는 www.metroupdates.com을 방문하시거나 저희 교통 알림 앱인 Metro Alert를 다운로드하여 확인하실 수 있습니다.`,

  koreanNouns: `SERVICE DISRUPTION NOTICE

Currently, train service on the Blue Line is experiencing delays due to an ongoing labor <mark>파업</mark> affecting station staff and maintenance <mark>인력</mark>.

Efforts are being made to resolve the situation as soon as possible. Until normal service resumes, trains will be running on a reduced schedule, and wait times may be longer than usual between Lincoln Square and Jefferson Avenue Stations.

For the latest updates on service changes and schedules, please visit www.metroupdates.com or download our transit notification app, Metro Alert.`,
  wordPairs: {
    strike: "파업",
    crews: "인력",
  },

  questions: [],
};
const announcement18 = {
  id: 18,
  passage: `ATTENTION COMMUTERS

To improve service during peak hours, additional trains will be running on the Green Line starting next Monday.

During weekday mornings and evenings, extra trains will operate between Maplewood Station and Downtown Central, reducing wait times for <mark>commuters</mark>.

The updated schedule is as follows:

• Morning rush hour: Additional trains every 10 minutes from 6:30 AM to 9:30 AM.
• Evening rush hour: Additional trains every 12 minutes from 4:30 PM to 7:00 PM.
• Commuters are encouraged to take advantage of these additional services for a smoother and faster journey.

For more details on the updated schedule, please visit www.citytransitupdates.com or download the Metro Commute app.`,

  translation: `승객 여러분께 알림

다음 주 월요일부터 출퇴근 시간대의 서비스 개선을 위해 그린 라인에 추가 열차가 운행될 예정입니다.

평일 아침과 저녁 시간대에 메이플우드역과 다운타운 센트럴역 사이에 추가 열차가 운행되어 승객들의 대기 시간이 단축될 예정입니다.

변경된 일정은 다음과 같습니다:

아침 출근 시간: 오전 6:30부터 9:30까지 10분 간격으로 추가 열차 운행
저녁 퇴근 시간: 오후 4:30부터 7:00까지 12분 간격으로 추가 열차 운행
승객 여러분께서는 더욱 원활하고 신속한 이동을 위해 이 추가 서비스를 이용해 주시기 바랍니다.

변경된 일정에 대한 자세한 내용은 www.citytransitupdates.com을 방문하시거나 Metro Commute 앱을 다운로드하여 확인하실 수 있습니다.`,
  koreanNouns: `ATTENTION COMMUTERS

To improve service during peak hours, additional trains will be running on the Green Line starting next Monday.

During weekday mornings and evenings, extra trains will operate between Maplewood Station and Downtown Central, reducing wait times for <mark>승객</mark>.

The updated schedule is as follows:

• Morning rush hour: Additional trains every 10 minutes from 6:30 AM to 9:30 AM.
• Evening rush hour: Additional trains every 12 minutes from 4:30 PM to 7:00 PM.
• Commuters are encouraged to take advantage of these additional services for a smoother and faster journey.

For more details on the updated schedule, please visit www.citytransitupdates.com or download the Metro Commute app.`,

  wordPairs: {
    commuters: "승객",
  },

  questions: [],
};
const announcement19 = {
  id: 19,
  passage: `Maplewood Apartments will be conducting fire alarm testing in all units from March 12 to 16. The building supervisor will <mark>accompany</mark> a technician from SafeGuard Systems as they inspect the alarms. Each test will take approximately 45 minutes.

The <mark>inspection</mark> will include a check for the following:

• Smoke detector functionality
• Fire alarm volume
• Battery replacement needs

You will receive additional information in your mailbox to let you know when your test is scheduled. On the day of the test, you'll also receive text-message alerts notifying you when the technician enters and exits your unit.

Residents of Units 1 to 25 will receive their test report on March 18.
Residents of Units 26 to 50 will receive their test report on March 22.`,

  translation: `메이플우드 아파트는 3월 12일부터 16일까지 모든 세대의 화재 경보기 점검을 실시할 예정입니다. 건물 관리인이 SafeGuard Systems의 기술자와 함께 경보기를 점검할 예정입니다. 각 점검은 약 45분이 소요됩니다.

점검 항목은 다음과 같습니다:

연기 감지기 기능
화재 경보음 크기
배터리 교체 필요 여부

귀하의 점검 일정을 알려드리는 추가 정보를 우편함으로 전달해 드릴 예정입니다. 점검 당일에는 기술자가 귀하의 세대에 출입할 때 문자 메시지로도 알려드립니다.

1동부터 25동 거주자는 3월 18일에 점검 보고서를 받으실 수 있습니다.
26동부터 50동 거주자는 3월 22일에 점검 보고서를 받으실 수 있습니다.`,

  koreanNouns: `Maplewood Apartments will be conducting fire alarm testing in all units from March 12 to 16. The building supervisor will <mark>동행하다</mark> a technician from SafeGuard Systems as they inspect the alarms. Each test will take approximately 45 minutes.

The <mark>점검</mark> will include a check for the following:

• Smoke detector functionality
• Fire alarm volume
• Battery replacement needs

You will receive additional information in your mailbox to let you know when your test is scheduled. On the day of the test, you'll also receive text-message alerts notifying you when the technician enters and exits your unit.

Residents of Units 1 to 25 will receive their test report on March 18.
Residents of Units 26 to 50 will receive their test report on March 22.`,
  wordPairs: {
    accompany: "동행하다",
    inspection: "점검",
  },

  questions: [],
};
const announcement20 = {
  id: 20,
  passage: `IMPORTANT MESSAGE FOR RESIDENTS

Recently, there has been an increase in <mark>false</mark> fire alarm activations due to <mark>improper</mark> use. These <mark>incidents</mark> cause unnecessary panic, <mark>disrupt</mark> daily activities, and waste emergency resources.

We remind all residents that <mark>tampering</mark> with or falsely activating fire alarms is <mark>strictly</mark> prohibited. Anyone found responsible for such actions may <mark>face</mark> penalties, including fines or further <mark>legal consequences</mark>.

Fire alarms are essential for ensuring everyone's safety. Please use them responsibly and report any <mark>suspicious</mark> behavior to building management immediately.

For any concerns or inquiries, please contact the management office at (555) 123-4567.

Thank you for your cooperation in keeping our community safe.`,

  translation: `입주민 여러분께 드리는 중요 공지사항

최근 부적절한 사용으로 인한 화재 경보기 오작동이 증가하고 있습니다. 이러한 사고는 불필요한 공포를 야기하고, 일상생활을 방해하며, 응급 자원을 낭비하게 됩니다.

화재 경보기를 조작하거나 허위로 작동시키는 것은 엄격히 금지되어 있음을 모든 입주민께 상기시켜 드립니다. 이러한 행위에 책임이 있는 것으로 밝혀진 사람은 벌금이나 추가적인 법적 제재를 포함한 처벌을 받을 수 있습니다.

화재 경보기는 모든 사람의 안전을 보장하는 데 필수적입니다. 책임감 있게 사용해 주시고 의심스러운 행동을 발견하시면 즉시 건물 관리팀에 신고해 주시기 바랍니다.

문의사항이나 우려사항이 있으시면 관리사무소 (555) 123-4567로 연락해 주시기 바랍니다.

우리 공동체의 안전을 지키는 데 협조해 주셔서 감사합니다.`,

  koreanNouns: `IMPORTANT MESSAGE FOR RESIDENTS

Recently, there has been an increase in <mark>허위</mark> fire alarm activations due to <mark>부적절한</mark> use. These <mark>사고</mark> cause unnecessary panic, <mark>방해하다</mark> daily activities, and waste emergency resources.

We remind all residents that <mark>조작하는</mark> with or falsely activating fire alarms is <mark>엄격히</mark> prohibited. Anyone found responsible for such actions may <mark>마주하다</mark> penalties, including fines or further <mark>법적 제재</mark>.

Fire alarms are essential for ensuring everyone's safety. Please use them responsibly and report any <mark>의심스러운</mark> behavior to building management immediately.

For any concerns or inquiries, please contact the management office at (555) 123-4567.

Thank you for your cooperation in keeping our community safe.`,

  wordPairs: {
    false: "허위",
    improper: "부적절한",
    incidents: "사고",
    disrupt: "방해하다",
    tampering: "조작하는",
    strictly: "엄격히",
    face: "마주하다",
    "legal consequences": "법적 제재",
    suspicious: "의심스러운",
  },

  questions: [],
};

const announcement21 = {
  id: 21,
  passage: `GRAND OPENING OF URBAN BITE
We are excited to announce the Grand Opening of Urban Bite – your new go-to spot for gourmet burgers and handcrafted milkshakes.

Date: Friday, April 26, 2025
Location: 456 Downtown Ave, New York
Time: 11:00 AM – 10:00 PM

Opening Day Specials:
First 50 customers get a free signature burger
Buy one milkshake, get one free
Live DJ performance and special <mark>giveaways</mark>
Come celebrate with us and enjoy the best burgers in town, made fresh with <mark>locally</mark> sourced ingredients.

For more updates, follow us on Instagram @urbanbiteofficial or visit www.urbanbite.com.

We look forward to serving you on opening day.`,

  translation: `어반 바이트 그랜드 오픈
고메 버거와 수제 밀크쉐이크를 즐길 수 있는 새로운 명소, 어반 바이트의 그랜드 오픈을 기쁜 마음으로 알려드립니다.

날짜: 2025년 4월 26일 금요일
위치: 뉴욕 다운타운 애비뉴 456번지
시간: 오전 11시 - 오후 10시

오픈일 특별 혜택:

선착순 50명 고객님께 시그니처 버거 무료 제공
밀크쉐이크 1+1
DJ 라이브 공연과 특별 경품 증정
지역 농산물로 신선하게 만든 최고의 버거와 함께 저희의 오픈을 축하해 주세요.

더 많은 소식은 인스타그램 @urbanbiteofficial을 팔로우하시거나 www.urbanbite.com을 방문해 주세요.

오픈일에 여러분을 만나 뵙기를 기대합니다.`,

  koreanNouns: `GRAND OPENING OF URBAN BITE
We are excited to announce the Grand Opening of Urban Bite – your new go-to spot for gourmet burgers and handcrafted milkshakes.

Date: Friday, April 26, 2025
Location: 456 Downtown Ave, New York
Time: 11:00 AM – 10:00 PM

Opening Day Specials:
First 50 customers get a free signature burger
Buy one milkshake, get one free
Live DJ performance and special <mark>경품 증정</mark>
Come celebrate with us and enjoy the best burgers in town, made fresh with <mark>지역</mark> sourced ingredients.

For more updates, follow us on Instagram @urbanbiteofficial or visit www.urbanbite.com.

We look forward to serving you on opening day.`,

  wordPairs: {
    giveaways: "경품 증정",
    locally: "지역",
  },

  questions: [],
};

const announcement22 = {
  id: 22,
  passage: `Attention Group Visitors to the Grand City Museum

The Grand City Museum welcomes all visitors, including tour groups and <mark>school excursions</mark>. However, to ensure the best experience for everyone and to protect our valuable exhibits, we kindly ask for your cooperation.

Museum staff have requested that all visitors maintain a respectful distance from artworks and <mark>displays</mark>. Touching exhibits is strictly prohibited to prevent damage.

Additionally, group leaders and tour guides are encouraged to remind their participants to observe <mark>artifacts</mark> from a safe distance and follow museum guidelines at all times.

For further inquiries, please visit the information desk or refer to our official website at www.grandcitymuseum.com.

Thank you for helping us <mark>preserve</mark> history and art for future generations.`,

  translation: `그랜드 시티 박물관 단체 관람객 여러분께 안내드립니다

그랜드 시티 박물관은 관광 단체와 학교 견학을 포함한 모든 방문객을 환영합니다. 하지만 모든 분들의 최상의 관람 경험과 소중한 전시품 보호를 위해 여러분의 협조를 부탁드립니다.

박물관 직원들은 모든 방문객들이 예술 작품과 전시품으로부터 적절한 거리를 유지해 주실 것을 요청드립니다. 전시품 손상 방지를 위해 전시품 접촉은 엄격히 금지됩니다.

또한 단체 인솔자와 가이드들은 참가자들에게 유물을 안전한 거리에서 관람하고 항상 박물관 지침을 준수하도록 상기시켜 주시기 바랍니다.

추가 문의사항이 있으시면 안내 데스크를 방문하시거나 공식 웹사이트 www.grandcitymuseum.com을 참조해 주시기 바랍니다.

미래 세대를 위한 역사와 예술 보존에 협조해 주셔서 감사합니다.`,

  koreanNouns: `Attention Group Visitors to the Grand City Museum

The Grand City Museum welcomes all visitors, including tour groups and <mark>학교 견학</mark>. However, to ensure the best experience for everyone and to protect our valuable exhibits, we kindly ask for your cooperation.

Museum staff have requested that all visitors maintain a respectful distance from artworks and <mark>전시품</mark>. Touching exhibits is strictly prohibited to prevent damage.

Additionally, group leaders and tour guides are encouraged to remind their participants to observe <mark>유물</mark> from a safe distance and follow museum guidelines at all times.

For further inquiries, please visit the information desk or refer to our official website at www.grandcitymuseum.com.

Thank you for helping us <mark>보존하다</mark> history and art for future generations.`,

  wordPairs: {
    "school excursions": "학교 견학",
    displays: "전시품",
    artifacts: "유물",
    preserve: "보존하다",
  },

  questions: [],
};
const announcement23 = {
  id: 23,
  passage: `Attention Library Visitors
  
The City Public Library welcomes all guests, including students, researchers, and casual readers. To maintain a comfortable and fair environment for everyone, we kindly ask for your cooperation.

Recently, there have been <mark>concerns</mark> regarding visitors reserving multiple seats for extended periods. To ensure fair access, we ask that seats remain available for those actively using them. Please do not place <mark>personal belongings</mark> on chairs to hold spaces for others.

Additionally, during peak hours, we encourage visitors to use <mark>designated</mark> group study rooms for discussions and avoid occupying reading areas for non-reading activities.

For more information on library policies, please visit the help desk or check our website at www.citylibrary.com.

Thank you for your cooperation in making the library a welcoming space for all.`,

  translation: `도서관 이용객 여러분께 안내드립니다

시립 도서관은 학생, 연구자, 일반 독서자를 포함한 모든 방문객을 환영합니다. 모든 분들을 위한 편안하고 공정한 환경을 유지하기 위해 여러분의 협조를 부탁드립니다.

최근 장시간 동안 여러 좌석을 예약하는 이용객들에 대한 우려가 있었습니다. 공정한 이용을 보장하기 위해, 실제로 사용하시는 분들을 위해 좌석을 비워두시기 바랍니다. 다른 사람을 위해 좌석에 개인 물품을 놓아두는 것을 삼가해 주시기 바랍니다.

또한 이용이 많은 시간대에는 토론을 위해 지정된 그룹 스터디룸을 이용해 주시고, 독서 공간에서 독서 외 활동을 하지 않도록 해주시기 바랍니다.

도서관 정책에 대한 자세한 정보는 안내 데스크를 방문하시거나 웹사이트 www.citylibrary.com을 확인해 주시기 바랍니다.

모든 분들을 위한 환영받는 공간을 만드는 데 협조해 주셔서 감사합니다.`,

  koreanNouns: `Attention Library Visitors
  
The City Public Library welcomes all guests, including students, researchers, and casual readers. To maintain a comfortable and fair environment for everyone, we kindly ask for your cooperation.

Recently, there have been <mark>우려들</mark> regarding visitors reserving multiple seats for extended periods. To ensure fair access, we ask that seats remain available for those actively using them. Please do not place <mark>개인 물품</mark> on chairs to hold spaces for others.

Additionally, during peak hours, we encourage visitors to use <mark>지정된</mark> group study rooms for discussions and avoid occupying reading areas for non-reading activities.

For more information on library policies, please visit the help desk or check our website at www.citylibrary.com.

Thank you for your cooperation in making the library a welcoming space for all.`,

  wordPairs: {
    concerns: "우려들",
    "personal belongings": "개인 물품",
    designated: "지정된",
  },

  questions: [],
};

const announcement24 = {
  id: 24,
  passage: `Pet Policy for City Park Visitors

The City Park welcomes all visitors, including those with pets. To ensure a safe and enjoyable experience for everyone, we kindly ask pet owners to follow these guidelines:

All pets must be kept on a <mark>leash</mark> at all times. 
This helps prevent <mark>disturbances</mark> and ensures the safety of both pets and other visitors. Owners are responsible for cleaning up after their pets. 

Waste <mark>disposal</mark> stations are located <mark>throughout</mark> the park for your convenience.

Pets are not allowed in designated picnic areas, playgrounds, or inside park facilities. Please use the pet-friendly zones for your activities.

Aggressive or <mark>disruptive</mark> animals may be asked to leave. If your pet shows signs of <mark>aggression</mark>, we recommend using a <mark>muzzle</mark> or avoiding crowded areas.

By following these rules, we can keep the park clean and enjoyable for everyone. For more information, visit www.citypark.com or contact park management.

Thank you for your cooperation.`,

  translation: `공원 방문객을 위한 반려동물 정책

시티 공원은 반려동물을 동반한 방문객을 포함한 모든 방문객을 환영합니다. 모든 분들의 안전하고 즐거운 경험을 위해 반려동물 보호자께서는 다음 지침을 따라주시기 바랍니다:

모든 반려동물은 항상 목줄을 착용해야 합니다. 
이는 소란을 방지하고 반려동물과 다른 방문객의 안전을 보장하는 데 도움이 됩니다.
보호자는 반려동물의 배변 처리에 책임이 있습니다. 
편의를 위해 공원 곳곳에 배변 처리 시설이 마련되어 있습니다.
반려동물은 지정된 피크닉 구역, 놀이터 또는 공원 시설 내부에 출입할 수 없습니다. 활동 시에는 반려동물 친화 구역을 이용해 주시기 바랍니다.
공격적이거나 소란스러운 동물은 퇴장을 요청받을 수 있습니다. 반려동물이 공격성을 보이는 경우, 입마개 사용이나 혼잡한 구역 피하기를 권장합니다.

이러한 규칙을 준수함으로써 모든 분들을 위해 공원을 깨끗하고 즐거운 공간으로 유지할 수 있습니다. 자세한 정보는 www.citypark.com을 방문하시거나 공원 관리부에 문의해 주시기 바랍니다.

협조해 주셔서 감사합니다.`,

  koreanNouns: `Pet Policy for City Park Visitors

The City Park welcomes all visitors, including those with pets. To ensure a safe and enjoyable experience for everyone, we kindly ask pet owners to follow these guidelines:

All pets must be kept on a <mark>목줄</mark> at all times. 
This helps prevent <mark>소란</mark> and ensures the safety of both pets and other visitors. Owners are responsible for cleaning up after their pets. 

Waste <mark>처리</mark> stations are located <mark>곳곳에</mark> the park for your convenience.

Pets are not allowed in designated picnic areas, playgrounds, or inside park facilities. Please use the pet-friendly zones for your activities.

Aggressive or <mark>소란스러운</mark> animals may be asked to leave. If your pet shows signs of <mark>공격성</mark>, we recommend using a <mark>입마개</mark> or avoiding crowded areas.

By following these rules, we can keep the park clean and enjoyable for everyone. For more information, visit www.citypark.com or contact park management.

Thank you for your cooperation.`,

  wordPairs: {
    leash: "목줄",
    disturbances: "소란",
    disposal: "처리",
    throughout: "곳곳에",
    disruptive: "소란스러운",
    aggression: "공격성",
    muzzle: "입마개",
  },

  questions: [],
};

const announcement25 = {
  id: "announcement25",
  title: "Creative Writing for Beginners – Free Workshop",
  passage: `Creative Writing for Beginners – Free Workshop at City Community Center

The City Community Center, in collaboration with the Downtown Public Library, is offering a six-week creative writing workshop for beginners who want to develop their storytelling and writing skills. This program is ideal for those interested in fiction, memoir writing, or personal essays.

Workshop Details:
• Dates: April 10 – May 15 (Every Wednesday)
• Time: 6:30 PM – 8:30 PM
• Location: City Community Center, Room 204
• <mark>Eligibility</mark>: Open to adults (18+)

Program Highlights:
Introduction to storytelling – Learn the key elements of great writing
Character and plot development – Create <mark>compelling</mark> stories with strong narratives
Writing exercises and peer feedback – Practice in a supportive environment
Special guest speaker: Local author Jane Patterson – Insights from a published writer
Final session: Open reading night – Share your work with the group

This workshop is free of charge, but space is limited. Participants must register in advance at www.citycommunitycenter.com or sign up at the front desk.

For more details, contact (555) 123-4567.

Join us and bring your stories to life!`,

  translation: `초보자를 위한 창작 글쓰기 - 무료 워크숍

시티 커뮤니티 센터는 다운타운 공공도서관과 협력하여 스토리텔링과 글쓰기 능력을 개발하고자 하는 초보자를 위한 6주 과정의 창작 글쓰기 워크숍을 제공합니다. 이 프로그램은 소설, 회고록 작성 또는 개인 에세이에 관심이 있는 분들에게 이상적입니다.

워크숍 세부사항:
날짜: 4월 10일 - 5월 15일 (매주 수요일)
시간: 오후 6:30 - 오후 8:30
장소: 시티 커뮤니티 센터, 204호실
참가자격: 성인 (18세 이상)

프로그램 하이라이트:
스토리텔링 입문 - 훌륭한 글쓰기의 핵심 요소 학습
캐릭터와 플롯 개발 - 강력한 서사를 가진 매력적인 이야기 창작
글쓰기 연습과 동료 피드백 - 지지적인 환경에서의 실습
특별 초청 강연자: 지역 작가 제인 패터슨 - 출판 작가의 통찰력
마지막 세션: 낭독회 - 그룹과 작품 공유

이 워크숍은 무료이지만 자리가 제한되어 있습니다. 참가자는 www.citycommunitycenter.com에서 사전 등록하거나 안내 데스크에서 신청해야 합니다.

자세한 내용은 (555) 123-4567로 문의하시기 바랍니다.

참여하셔서 여러분의 이야기에 생명을 불어넣어보세요!`,

  koreanNouns: `Creative Writing for Beginners – Free Workshop at City Community Center

The City Community Center, in collaboration with the Downtown Public Library, is offering a six-week creative writing workshop for beginners who want to develop their storytelling and writing skills. This program is ideal for those interested in fiction, memoir writing, or personal essays.

Workshop Details:
• Dates: April 10 – May 15 (Every Wednesday)
• Time: 6:30 PM – 8:30 PM
• Location: City Community Center, Room 204
• <mark>자격</mark>: Open to adults (18+)

Program Highlights:
Introduction to storytelling – Learn the key elements of great writing
Character and plot development – Create <mark>매력적인</mark> stories with strong narratives
Writing exercises and peer feedback – Practice in a supportive environment
Special guest speaker: Local author Jane Patterson – Insights from a published writer
Final session: Open reading night – Share your work with the group

This workshop is free of charge, but space is limited. Participants must register in advance at www.citycommunitycenter.com or sign up at the front desk.

For more details, contact (555) 123-4567.

Join us and bring your stories to life!`,
  wordPairs: {
    Eligibility: "자격",
    compelling: "매력적인",
  },

  questions: [],
};

const announcement27 = {
  id: "announcement27",
  title: "City Arts Festival",
  passage: `City Arts Festival

When: September 15-17
Where: Downtown Cultural Center, Main Plaza

Are you <mark>passionate</mark> about art, music, or creative performances? Join us at the City Arts Festival to experience a weekend filled with live performances, art exhibitions, and hands-on workshops led by <mark>renowned</mark> artists. The event is free for all visitors, thanks to sponsorship from the City of Brookdale.

The festival will feature a diverse lineup, including:

• Live painting and sculpture demonstrations
• Music and dance performances from local and international artists
• Creative writing and storytelling sessions
• Interactive workshops on photography, digital art, and printmaking

Visitors are encouraged to explore the local artisan market and enjoy exclusive festival discounts on handcrafted goods. Additionally, the Downtown Cultural Center will be offering free guided tours of its latest art exhibition during the event.

For more information, visit www.cityartsfestival.com or contact the event office at (555) 678-9012.
Don't miss this opportunity to celebrate creativity and culture in the heart of the city!`,

  translation: `시티 아트 페스티벌

일시: 9월 15일-17일
장소: 다운타운 문화센터, 메인 광장

예술, 음악 또는 창작 공연에 열정이 있으신가요? 시티 아트 페스티벌에서 유명 예술가들이 이끄는 라이브 공연, 예술 전시회, 체험형 워크숍으로 가득한 주말을 경험해보세요. 브룩데일 시의 후원 덕분에 모든 방문객에게 무료로 개방됩니다.

페스티벌에서는 다음과 같은 다양한 프로그램이 진행됩니다:

라이브 페인팅과 조각 시연
국내외 아티스트들의 음악과 댄스 공연
창작 글쓰기와 스토리텔링 세션
사진, 디지털 아트, 판화 제작 체험형 워크숍
방문객들은 지역 장인 시장을 둘러보고 수공예품에 대한 페스티벌 특별 할인을 즐기실 수 있습니다. 또한, 다운타운 문화센터는 행사 기간 동안 최신 예술 전시회의 무료 가이드 투어를 제공합니다.

자세한 내용은 www.cityartsfestival.com을 방문하시거나 행사 사무실 (555) 678-9012로 문의하시기 바랍니다.

도시의 중심에서 창의성과 문화를 축하하는 이 기회를 놓치지 마세요!`,

  koreanNouns: `City Arts Festival

When: September 15-17
Where: Downtown Cultural Center, Main Plaza

Are you <mark>열정</mark> about art, music, or creative performances? Join us at the City Arts Festival to experience a weekend filled with live performances, art exhibitions, and hands-on workshops led by <mark>유명한</mark> artists. The event is free for all visitors, thanks to sponsorship from the City of Brookdale.

The festival will feature a diverse lineup, including:

• Live painting and sculpture demonstrations
• Music and dance performances from local and international artists
• Creative writing and storytelling sessions
• Interactive workshops on photography, digital art, and printmaking

Visitors are encouraged to explore the local artisan market and enjoy exclusive festival discounts on handcrafted goods. Additionally, the Downtown Cultural Center will be offering free guided tours of its latest art exhibition during the event.

For more information, visit www.cityartsfestival.com or contact the event office at (555) 678-9012.
Don't miss this opportunity to celebrate creativity and culture in the heart of the city!`,
  wordPairs: {
    passionate: "열정",
    renowned: "유명한",
  },

  questions: [],
};
const announcement28 = {
  id: "announcement28",
  title: "Grand Horizon Hotel Welcomes a Seasoned Professional",
  passage: `Grand Horizon Hotel Welcomes a Seasoned Professional

Grand Horizon Hotel, a <mark>renowned</mark> luxury resort chain, has <mark>appointed</mark> Martin Caldwell as the new guest experience manager at its flagship location.
Mr. Caldwell will officially take on his responsibilities starting April 1—just in time for the peak holiday season.

With over 18 years of <mark>extensive</mark> experience in the hospitality industry, he has <mark>honed</mark> his skills at some of the most <mark>prestigious</mark> hotels across Europe and North America.
Most recently, he played a <mark>pivotal</mark> role in enhancing customer satisfaction as the operations director at our Paris branch.
Thanks to his outstanding leadership and exceptional problem-solving abilities, he is expected to make significant <mark>contributions</mark> to our hotel's success.

At Grand Horizon Hotel, Mr. Caldwell will <mark>oversee</mark> all customer service operations, ensuring that every guest enjoys a <mark>seamless</mark> and memorable stay.
He will supervise the front desk team, guaranteeing efficient check-in and check-out procedures.

Additionally, he will lead specialized training sessions for staff to <mark>uphold</mark> the highest standards of service.
Finally, he will design exclusive leisure programs, offering guests a diverse selection of recreational activities, from fine dining experiences to guided city tours.`,

  translation: `그랜드 호라이즌 호텔, 경험 많은 전문가 영입

그랜드 호라이즌 호텔, 유명한 럭셔리 리조트 체인은 마틴 콜드웰을 플래그십 지점의 새로운 고객 경험 매니저로 임명했습니다.
콜드웰 씨는 4월 1일부터 공식적으로 업무를 시작하며, 이는 성수기 시즌에 맞춰 진행됩니다.

호텔 산업에서 18년 이상의 풍부한 경험을 가진 그는 유럽과 북미 전역의 가장 명망 있는 호텔들에서 자신의 기술을 연마해왔습니다.
가장 최근에는 파리 지점의 운영 이사로서 고객 만족도 향상에 중추적인 역할을 했습니다.
그의 뛰어난 리더십과 탁월한 문제 해결 능력 덕분에 그는 우리 호텔의 성공에 중요한 기여를 할 것으로 기대됩니다.

그랜드 호라이즌 호텔에서 콜드웰 씨는 모든 고객 서비스 운영을 감독하여 모든 투숙객이 원활하고 기억에 남는 숙박을 즐길 수 있도록 할 것입니다.
그는 프론트 데스크 팀을 감독하여 효율적인 체크인 및 체크아웃 절차를 보장할 것입니다.
또한, 그는 직원들을 위한 전문 교육 세션을 이끌어 최고 수준의 서비스를 유지할 것입니다.
마지막으로, 그는 고급 다이닝 경험부터 가이드 도시 투어까지 다양한 레크리에이션 활동을 제공하는 독점적인 레저 프로그램을 설계할 것입니다.`,
  koreanNouns: `Grand Horizon Hotel Welcomes a Seasoned Professional

  Grand Horizon Hotel, a <mark>유명한</mark> luxury resort chain, has <mark>임명하다</mark> Martin Caldwell as the new guest experience manager at its flagship location.
  Mr. Caldwell will officially take on his responsibilities starting April 1—just in time for the peak holiday season.
  
  With over 18 years of <mark>풍부한</mark> experience in the hospitality industry, he has <mark>연마하다</mark> his skills at some of the most <mark>명망 있는</mark> hotels across Europe and North America.
  Most recently, he played a <mark>중추적인</mark> role in enhancing customer satisfaction as the operations director at our Paris branch.
  Thanks to his outstanding leadership and exceptional problem-solving abilities, he is expected to make significant <mark>기여</mark> to our hotel's success.
  
  At Grand Horizon Hotel, Mr. Caldwell will <mark>감독하다</mark> all customer service operations, ensuring that every guest enjoys a <mark>원활한</mark> and memorable stay.
  He will supervise the front desk team, guaranteeing efficient check-in and check-out procedures.
  
  Additionally, he will lead specialized training sessions for staff to <mark>유지하다</mark> the highest standards of service.
  Finally, he will design exclusive leisure programs, offering guests a diverse selection of recreational activities, from fine dining experiences to guided city tours.`,
  wordPairs: {
    renowned: "유명한",
    appointed: "임명하다",
    extensive: "풍부한",
    honed: "연마하다",
    prestigious: "명망 있는",
    pivotal: "중추적인",
    contributions: "기여",
    oversee: "감독하다",
    seamless: "원활한",
    uphold: "유지하다",
  },

  questions: [],
};

const announcement29 = {
  id: "announcement29",
  title: "Aurora Airlines Introduces a New Customer Service Director",
  passage: `Aurora Airlines Introduces a New Customer Service Director

Aurora Airlines, a leading international <mark>carrier</mark> known for its exceptional in-flight experience, has <mark>appointed</mark> David Whitmore as its new customer service director. 
He will officially <mark>assume</mark> his role on June 1, just as the airline prepares for an anticipated <mark>surge</mark> in summer travel.

With over 18 years of experience in the <mark>aviation industry</mark>, Mr. Whitmore has built an <mark>outstanding</mark> reputation for improving passenger satisfaction and optimizing service operations. 
Most recently, he played a key role in enhancing <mark>onboard amenities</mark> and streamlining check-in processes at a major airline in Canada. 
His keen attention to detail and strategic leadership have consistently resulted in higher efficiency and improved customer loyalty.

At Aurora Airlines, Mr. Whitmore will be responsible for overseeing all customer service initiatives, ensuring that passengers receive seamless and top-tier support throughout their journey. 
He will implement innovative training programs for staff, refine complaint resolution procedures, and introduce new digital self-service tools to enhance efficiency. Additionally, he will collaborate with the marketing team to develop exclusive loyalty programs, rewarding frequent travelers with premium benefits.`,

  translation: `오로라 항공, 새로운 고객 서비스 이사 소개

오로라 항공, 탁월한 기내 경험으로 알려진 선도적인 국제 항공사는 데이비드 휘트모어를 새로운 고객 서비스 이사로 임명했습니다. 그는 항공사가 여름 여행 성수기를 대비하는 6월 1일부터 공식적으로 역할을 맡게 됩니다.

항공 산업에서 18년 이상의 경험을 가진 휘트모어 씨는 승객 만족도 향상과 서비스 운영 최적화에 탁월한 평판을 쌓아왔습니다. 가장 최근에는 캐나다의 주요 항공사에서 기내 편의 시설 개선 및 체크인 프로세스 간소화에 중요한 역할을 했습니다. 그의 세심한 주의력과 전략적 리더십은 지속적으로 높은 효율성과 향상된 고객 충성도로 이어졌습니다.

오로라 항공에서 휘트모어 씨는 모든 고객 서비스 이니셔티브를 감독하여 승객들이 여정 전반에 걸쳐 원활하고 최고 수준의 지원을 받을 수 있도록 할 책임이 있습니다. 그는 직원들을 위한 혁신적인 교육 프로그램을 구현하고, 불만 해결 절차를 개선하며, 효율성을 높이기 위한 새로운 디지털 셀프 서비스 도구를 도입할 것입니다. 또한, 그는 마케팅 팀과 협력하여 단골 여행객에게 프리미엄 혜택을 제공하는 독점적인 충성도 프로그램을 개발할 것입니다.`,

  koreanNouns: `Aurora Airlines Introduces a New Customer Service Director

Aurora Airlines, a leading international <mark>항공사</mark> known for its exceptional in-flight experience, has <mark>임명했다</mark> David Whitmore as its new customer service director. 
He will officially <mark>맡는다</mark> his role on June 1, just as the airline prepares for an anticipated <mark>급증</mark> in summer travel.

With over 18 years of experience in the <mark>항공 산업</mark>, Mr. Whitmore has built an <mark>탁월한</mark> reputation for improving passenger satisfaction and optimizing service operations. 
Most recently, he played a key role in enhancing <mark>기내 편의 시설</mark> and streamlining check-in processes at a major airline in Canada. 
His keen attention to detail and strategic leadership have consistently resulted in higher efficiency and improved customer loyalty.

At Aurora Airlines, Mr. Whitmore will be responsible for overseeing all customer service initiatives, ensuring that passengers receive seamless and top-tier support throughout their journey. 
He will implement innovative training programs for staff, refine complaint resolution procedures, and introduce new digital self-service tools to enhance efficiency. Additionally, he will collaborate with the marketing team to develop exclusive loyalty programs, rewarding frequent travelers with premium benefits.`,
  wordPairs: {
    carrier: "항공사",
    appointed: "임명했다",
    assume: "맡는다",
    surge: "급증",
    "aviation industry": "항공 산업",
    outstanding: "탁월한",
    "onboard amenities": "기내 편의 시설",
  },

  questions: [],
};

const announcement30 = {
  id: "announcement30",
  title: "Special Lecture Announcement",
  passage: `ANNOUNCEMENT: All students and faculty

Please be informed that Mr. Daniel Carter, a <mark>distinguished</mark> financial analyst from the Global Economic Research Center (GERC), will be delivering a special lecture on April 15. 
Mr. Carter will discuss <mark>emerging</mark> trends in international markets and provide valuable insights into economic forecasting. 
He is a <mark>seasoned</mark> expert in risk assessment and financial strategy, specializing in corporate investment planning. 
For the past 15 years, he has been working at GERC, where he has contributed to numerous influential studies.

His lecture will be held at the GBI main auditorium at 2 p.m. Seating is limited, so please reserve a spot by accessing the school's event portal, calling <mark>extension</mark> #412, or sending an e-mail to Emily Dawson at edawson@gbi.edu.

The lecture is free for faculty members and enrolled students, while visitors are required to pay a $20 admission fee.`,

  translation: `공지사항: 모든 학생 및 교직원

글로벌 경제 연구 센터(GERC)의 저명한 금융 분석가인 다니엘 카터 씨가 4월 15일에 특별 강연을 진행할 예정임을 알려드립니다. 카터 씨는 국제 시장의 새로운 동향에 대해 논의하고 경제 예측에 관한 귀중한 통찰력을 제공할 것입니다. 그는 위험 평가와 금융 전략 분야의 노련한 전문가로, 기업 투자 계획을 전문으로 합니다. 지난 15년 동안 그는 GERC에서 근무하며 수많은 영향력 있는 연구에 기여해 왔습니다.

강연은 GBI 메인 강당에서 오후 2시에 열릴 예정입니다. 좌석이 제한되어 있으므로 학교 이벤트 포털에 접속하거나, 내선 번호 #412로 전화하거나, 에밀리 도슨(edawson@gbi.edu)에게 이메일을 보내 자리를 예약해 주시기 바랍니다.

강연은 교직원과 등록된 학생들에게는 무료이며, 방문객은 20달러의 입장료를 지불해야 합니다.`,

  koreanNouns: `ANNOUNCEMENT: All students and faculty

Please be informed that Mr. Daniel Carter, a <mark>저명한</mark> financial analyst from the Global Economic Research Center (GERC), will be delivering a special lecture on April 15. 
Mr. Carter will discuss <mark>새로운</mark> trends in international markets and provide valuable insights into economic forecasting. 
He is a <mark>노련한</mark> expert in risk assessment and financial strategy, specializing in corporate investment planning. 
For the past 15 years, he has been working at GERC, where he has contributed to numerous influential studies.

His lecture will be held at the GBI main auditorium at 2 p.m. Seating is limited, so please reserve a spot by accessing the school's event portal, calling <mark>내선 번호</mark> #412, or sending an e-mail to Emily Dawson at edawson@gbi.edu.

The lecture is free for faculty members and enrolled students, while visitors are required to pay a $20 admission fee.`,
  wordPairs: {
    distinguished: "저명한",
    emerging: "새로운",
    seasoned: "노련한",
    extension: "내선 번호",
  },

  questions: [],
};

const announcement32 = {
  id: "announcement32",
  title: "Bright Future Education Foundation to Host Charity Dinner",
  passage: `Bright Future Education Foundation to Host Charity Dinner

The Bright Future Education Foundation sincerely appreciates the <mark>generous</mark> support it has received over the years. 
These contributions have enabled the organization to provide scholarships and essential learning materials to students in need.

We invite you to attend a <mark>charity dinner</mark> on October 20 at the Grandview Hotel Ballroom. 
It will be an evening <mark>dedicated to</mark> celebrating education and supporting underprivileged students. 
Tickets will be available for $80 per person, and all <mark>proceeds</mark> will directly fund scholarship programs.

In addition, a portion of the funds will go toward expanding mentorship initiatives to encourage professionals to volunteer as student mentors. 
These efforts are crucial to <mark>fostering</mark> educational opportunities and ensuring a brighter future for young learners in our community.`,

  translation: `브라이트 퓨처 교육 재단, 자선 만찬 개최 예정

브라이트 퓨처 교육 재단은 수년간 받아온 관대한 지원에 진심으로 감사드립니다. 이러한 기부 덕분에 재단은 도움이 필요한 학생들에게 장학금과 필수 학습 자료를 제공할 수 있었습니다.

10월 20일 그랜드뷰 호텔 연회장에서 열리는 자선 만찬에 여러분을 초대합니다. 이 행사는 교육을 축하하고 소외된 학생들을 지원하는 데 헌신하는 저녁이 될 것입니다. 티켓은 1인당 80달러에 판매되며, 모든 수익금은 장학금 프로그램에 직접 지원됩니다.

또한, 기금의 일부는 전문가들이 학생 멘토로 자원봉사하도록 장려하는 멘토십 이니셔티브를 확대하는 데 사용될 것입니다. 이러한 노력은 교육 기회를 촉진하고 우리 지역사회의 젊은 학습자들에게 더 밝은 미래를 보장하는 데 중요합니다.`,
  koreanNouns: `Bright Future Education Foundation to Host Charity Dinner

The Bright Future Education Foundation sincerely appreciates the <mark>관대한</mark> support it has received over the years. 
These contributions have enabled the organization to provide scholarships and essential learning materials to students in need.

We invite you to attend a <mark>자선 만찬</mark> on October 20 at the Grandview Hotel Ballroom. 
It will be an evening <mark>헌신하는</mark> celebrating education and supporting underprivileged students. 
Tickets will be available for $80 per person, and all <mark>수익금</mark> will directly fund scholarship programs.

In addition, a portion of the funds will go toward expanding mentorship initiatives to encourage professionals to volunteer as student mentors. 
These efforts are crucial to <mark>촉진하는</mark> educational opportunities and ensuring a brighter future for young learners in our community.`,
  wordPairs: {
    generous: "관대한",
    "charity dinner": "자선 만찬",
    "dedicated to": "헌신하는",
    proceeds: "수익금",
    fostering: "촉진하는",
  },

  questions: [],
};

const announcement33 = {
  id: "announcement33",
  title: "Riverside Public Library Notice",
  passage: `Riverside Public Library Notice

Starting June 5, the second-floor reading hall will be temporarily closed for renovations. 
The space requires <mark>thorough</mark> maintenance and modernization to ensure a more comfortable and efficient study environment for visitors. 
This essential upgrade will include installing improved <mark>lighting</mark>, upgrading seating arrangements, and enhancing <mark>soundproofing</mark> to minimize distractions.

Meanwhile, other library facilities, including the computer lab, study rooms, and lounge area, will remain accessible. 
Visitors are encouraged to use the first-floor reading section during this period. We sincerely apologize for any inconvenience and appreciate your patience as we work to improve the facility.

For the latest updates and announcements, please check our website or follow us on social media.`,

  translation: `리버사이드 공공 도서관 공지

6월 5일부터 2층 독서실이 리모델링을 위해 일시적으로 폐쇄됩니다. 이 공간은 방문객들에게 더 편안하고 효율적인 학습 환경을 보장하기 위해 철저한 유지보수와 현대화가 필요합니다. 이 필수적인 업그레이드에는 조명 개선, 좌석 배치 업그레이드, 그리고 방해 요소를 최소화하기 위한 방음 강화가 포함됩니다.

한편, 컴퓨터실, 스터디룸, 라운지 구역을 포함한 다른 도서관 시설들은 계속 이용 가능합니다. 이 기간 동안 방문객들은 1층 독서 구역을 이용하시기 바랍니다. 불편을 끼쳐드려 진심으로 사과드리며, 시설을 개선하는 동안 여러분의 인내심에 감사드립니다.

최신 업데이트와 공지사항은 저희 웹사이트를 확인하시거나 소셜 미디어를 팔로우해 주시기 바랍니다.`,

  koreanNouns: `Riverside Public Library Notice

Starting June 5, the second-floor reading hall will be temporarily closed for renovations. 
The space requires <mark>철저한</mark> maintenance and modernization to ensure a more comfortable and efficient study environment for visitors. 
This essential upgrade will include installing improved <mark>조명</mark>, upgrading seating arrangements, and enhancing <mark>방음</mark> to minimize distractions.

Meanwhile, other library facilities, including the computer lab, study rooms, and lounge area, will remain accessible. 
Visitors are encouraged to use the first-floor reading section during this period. We sincerely apologize for any inconvenience and appreciate your patience as we work to improve the facility.

For the latest updates and announcements, please check our website or follow us on social media.`,
  wordPairs: {
    thorough: "철저한",
    lighting: "조명",
    soundproofing: "방음",
  },

  questions: [],
};

const announcement34 = {
  id: "announcement34",
  title: "Metro Transit Service Update",
  passage: `Metro Transit Service Update

Starting July 10, several bus routes will be temporarily <mark>adjusted</mark> due to scheduled road maintenance in the downtown area. 
This necessary project aims to improve road conditions and enhance overall traffic flow, ensuring a safer and smoother <mark>commute</mark> for all passengers.

During this period, alternative routes will be available, and additional <mark>signage</mark> will be placed at key locations to assist commuters. 
Passengers are advised to check updated schedules and allow extra travel time to avoid delays.

We sincerely appreciate your understanding and cooperation. 
For real-time updates and route information, please visit our website or use the Metro Transit mobile app.`,

  translation: `지하철 교통 서비스 업데이트

7월 10일부터 시내 지역의 예정된 도로 유지보수로 인해 여러 버스 노선이 일시적으로 조정됩니다. 이 필요한 프로젝트는 도로 상태를 개선하고 전반적인 교통 흐름을 향상시켜 모든 승객들에게 더 안전하고 원활한 통근을 보장하는 것을 목표로 합니다.

이 기간 동안 대체 노선이 제공되며, 승객들을 돕기 위해 주요 위치에 추가 표지판이 설치될 것입니다. 승객들은 지연을 피하기 위해 업데이트된 일정을 확인하고 추가 이동 시간을 확보하는 것이 좋습니다.

여러분의 이해와 협조에 진심으로 감사드립니다. 실시간 업데이트 및 노선 정보를 위해 저희 웹사이트를 방문하거나 지하철 교통 모바일 앱을 사용해 주시기 바랍니다.`,
  koreanNouns: `Metro Transit Service Update

Starting July 10, several bus routes will be temporarily <mark>조정됩니다</mark> due to scheduled road maintenance in the downtown area. 
This necessary project aims to improve road conditions and enhance overall traffic flow, ensuring a safer and smoother <mark>통근</mark> for all passengers.

During this period, alternative routes will be available, and additional <mark>표지판</mark> will be placed at key locations to assist commuters. 
Passengers are advised to check updated schedules and allow extra travel time to avoid delays.

We sincerely appreciate your understanding and cooperation. 
For real-time updates and route information, please visit our website or use the Metro Transit mobile app.`,

  wordPairs: {
    adjusted: "조정됩니다",
    commute: "통근",
    signage: "표지판",
  },

  questions: [],
};

const announcement36 = {
  id: "announcement36",
  title: "Important Notice for MetroPark Members",
  passage: `Important Notice for MetroPark Members

Beginning in September, holders of the standard MetroPark <mark>pass</mark> will no longer have access to premium parking zones during peak hours. We understand that this may cause inconvenience, but this adjustment is necessary to improve overall traffic flow and enhance space availability for all visitors.

Current pass holders can continue using their <mark>existing</mark> benefits until the expiration of their current pass. <mark>Afterward</mark>, they will be seamlessly transitioned to an updated parking plan. To compensate for this change, 
MetroPark will provide a 20% discount on the next renewal, ensuring continued <mark>affordability</mark> for our loyal members.

Additionally, MetroPark has introduced several improvements to its parking system. 
Drivers can now reserve parking spots in advance through our mobile app, ensuring a <mark>hassle-free</mark> experience. 
Furthermore, for those traveling out of town, temporary <mark>suspension</mark> of parking privileges is now available without penalty.

Lastly, we have enhanced our rewards system, allowing frequent users to earn credits that can be redeemed for discounted rates and priority access. 
These updates are designed to make your parking experience more convenient, efficient, and <mark>tailored</mark> to your needs.

For more information, visit www.metropark.com or download our mobile app today.`,

  translation: `메트로파크 회원을 위한 중요 공지

9월부터 표준 메트로파크 이용권 소지자는 피크 시간대에 프리미엄 주차 구역에 더 이상 접근할 수 없게 됩니다. 이로 인해 불편을 초래할 수 있다는 점을 이해하지만, 이 조정은 전반적인 교통 흐름을 개선하고 모든 방문객을 위한 공간 가용성을 향상시키기 위해 필요합니다.

현재 이용권 소지자는 현재 이용권이 만료될 때까지 기존 혜택을 계속 사용할 수 있습니다. 그 후에는 업데이트된 주차 계획으로 원활하게 전환됩니다. 이러한 변경에 대한 보상으로, 메트로파크는 다음 갱신 시 20% 할인을 제공하여 충성 회원들을 위한 지속적인 경제성을 보장합니다.

또한, 메트로파크는 주차 시스템에 여러 개선 사항을 도입했습니다. 운전자는 이제 모바일 앱을 통해 주차 공간을 미리 예약할 수 있어 번거로움 없는 경험을 보장합니다. 더불어, 출장을 떠나는 사람들을 위해 주차 특권의 일시적 중단이 이제 벌금 없이 가능합니다.

마지막으로, 우리는 보상 시스템을 강화하여 자주 이용하는 사용자가 할인된 요금과 우선 접근을 위해 사용할 수 있는 크레딧을 적립할 수 있게 했습니다. 이러한 업데이트는 주차 경험을 더욱 편리하고, 효율적이며, 귀하의 필요에 맞게 맞춤화하도록 설계되었습니다.

자세한 정보는 www.metropark.com을 방문하거나 오늘 모바일 앱을 다운로드하세요.`,
  koreanNouns: `Important Notice for MetroPark Members

Beginning in September, holders of the standard MetroPark <mark>이용권</mark> will no longer have access to premium parking zones during peak hours. We understand that this may cause inconvenience, but this adjustment is necessary to improve overall traffic flow and enhance space availability for all visitors.

Current pass holders can continue using their <mark>기존의</mark> benefits until the expiration of their current pass. <mark>그 후에는</mark>, they will be seamlessly transitioned to an updated parking plan. To compensate for this change, 
MetroPark will provide a 20% discount on the next renewal, ensuring continued <mark>적당한 가격</mark> for our loyal members.

Additionally, MetroPark has introduced several improvements to its parking system. 
Drivers can now reserve parking spots in advance through our mobile app, ensuring a <mark>번거로움 없는</mark> experience. 
Furthermore, for those traveling out of town, temporary <mark>중단</mark> of parking privileges is now available without penalty.

Lastly, we have enhanced our rewards system, allowing frequent users to earn credits that can be redeemed for discounted rates and priority access. 
These updates are designed to make your parking experience more convenient, efficient, and <mark>맞춤화</mark> to your needs.

For more information, visit www.metropark.com or download our mobile app today.`,
  wordPairs: {
    pass: "이용권",
    existing: "기존의",
    Afterward: "그 후에는",
    affordability: "적당한 가격",
    "hassle-free": "번거로움 없는",
    suspension: "중단",
    tailored: "맞춤화",
  },

  questions: [],
};
const announcement37 = {
  id: "announcement37",
  title: "Riverfront Theater Film Screening",
  passage: `Riverfront Theater Presents Exclusive Film Screening

Riverfront Theater is thrilled to announce an exclusive <mark>premiere</mark> of Beyond the Horizon, a <mark>compelling</mark> documentary by award-winning filmmaker Julia Carter, on Friday, March 15, at 6:30 P.M. The event will run for approximately three hours, with the film's official screening lasting 120 minutes. 
Following the presentation, Ms. Carter will participate in an engaging Q&A session, offering unique insights into the filmmaking process.

Beyond the Horizon provides a captivating firsthand perspective on climate change's impact on remote island communities, documenting the filmmaker's <mark>immersive</mark> journey through the Pacific over <mark>the span of</mark> five years. 
If you are eager to experience this thought-provoking narrative, act swiftly—only a limited number of tickets are available.`,

  translation: `리버프론트 극장 독점 영화 상영회 개최

리버프론트 극장은 3월 15일 금요일 오후 6시 30분에 수상 경력이 있는 영화 제작자 줄리아 카터의 감동적인 다큐멘터리 '비욘드 더 호라이즌'의 독점 시사회를 개최하게 되어 기쁘게 생각합니다. 행사는 약 3시간 동안 진행되며, 영화 공식 상영 시간은 120분입니다. 상영 후에는 카터 감독이 참여하는 질의응답 시간이 마련되어 영화 제작 과정에 대한 독특한 통찰력을 제공할 예정입니다.

'비욘드 더 호라이즌'은 기후 변화가 외딴 섬 공동체에 미치는 영향에 대한 매력적인 직접적 관점을 제공하며, 5년에 걸친 영화 제작자의 태평양 몰입 여정을 기록합니다. 이 생각을 자극하는 이야기를 경험하고 싶으시다면 서둘러 행동하세요—티켓은 한정 수량만 이용 가능합니다.`,

  koreanNouns: `Riverfront Theater Presents Exclusive Film Screening

Riverfront Theater is thrilled to announce an exclusive <mark>시사회</mark> of Beyond the Horizon, a <mark>감동적인</mark> documentary by award-winning filmmaker Julia Carter, on Friday, March 15, at 6:30 P.M. The event will run for approximately three hours, with the film's official screening lasting 120 minutes. 
Following the presentation, Ms. Carter will participate in an engaging Q&A session, offering unique insights into the filmmaking process.

Beyond the Horizon provides a captivating firsthand perspective on climate change's impact on remote island communities, documenting the filmmaker's <mark>몰입하는</mark> journey through the Pacific over <mark>에 걸친</mark> five years. 
If you are eager to experience this thought-provoking narrative, act swiftly—only a limited number of tickets are available.`,
  wordPairs: {
    premiere: "시사회",
    compelling: "감동적인",

    immersive: "몰입하는",
    "the span of": "에 걸친",
  },

  questions: [],
};

const announcement39 = {
  id: "announcement39",
  title: "Community Workshop Registration Now Open",
  passage: `Community Workshop Registration Now Open

The annual Community Skills Workshop is set to begin on April 10 and will run until September 25. 
Now is the perfect time to secure your spot and enhance your skills in various hands-on courses. 
Returning participants will be eligible for a discounted registration fee of $30, while new attendees will be charged $50. 
Anyone residing in the area is encouraged to apply at www.communityworkshop.org.

However, please take note of the following guidelines:

Participants are responsible for bringing their own materials <mark>unless otherwise</mark> specified by the instructor.
Workstations must not <mark>be altered</mark> or expanded <mark>unless explicit</mark> approval is granted by workshop coordinators. 
Any <mark>modifications</mark> must be reviewed and authorized before implementation.
Attendees may only use <mark>designated spaces</mark> for their projects and must ensure that their work does not obstruct others.
Tools and equipment are available for shared use, but they must be returned <mark>promptly</mark> after each session.
The registration fee contributes to maintaining facilities, providing materials, and covering instructional costs.`,

  translation: `커뮤니티 워크숍 등록 지금 시작

연례 커뮤니티 기술 워크숍이 4월 10일에 시작하여 9월 25일까지 진행될 예정입니다. 지금이 자리를 확보하고 다양한 실습 과정에서 기술을 향상시킬 수 있는 완벽한 시간입니다. 재참가자는 30달러의 할인된 등록비가 적용되며, 신규 참가자는 50달러가 부과됩니다. 이 지역에 거주하는 모든 사람은 www.communityworkshop.org에서 신청하시기 바랍니다.

그러나 다음 지침에 유의하시기 바랍니다:

참가자는 강사가 별도로 명시하지 않는 한 자신의 재료를 가져와야 합니다.
워크스테이션은 워크숍 코디네이터의 명시적 승인 없이 변경하거나 확장해서는 안 됩니다. 모든 수정 사항은 실행 전에 검토 및 승인을 받아야 합니다.
참가자는 프로젝트를 위해 지정된 공간만 사용할 수 있으며 자신의 작업이 다른 사람을 방해하지 않도록 해야 합니다.
도구와 장비는 공동 사용이 가능하지만 각 세션 후에 즉시 반환해야 합니다.
등록비는 시설 유지, 재료 제공 및 교육 비용을 충당하는 데 기여합니다.`,

  koreanNouns: `Community Workshop Registration Now Open

The annual Community Skills Workshop is set to begin on April 10 and will run until September 25. 
Now is the perfect time to secure your spot and enhance your skills in various hands-on courses. 
Returning participants will be eligible for a discounted registration fee of $30, while new attendees will be charged $50. 
Anyone residing in the area is encouraged to apply at www.communityworkshop.org.

However, please take note of the following guidelines:

Participants are responsible for bringing their own materials <mark>별도로 명시하지 않는 한</mark> specified by the instructor.
Workstations must not <mark>변경되다</mark> or expanded <mark>명시적</mark> approval is granted by workshop coordinators. 
Any <mark>수정 사항</mark> must be reviewed and authorized before implementation.
Attendees may only use <mark>지정된 공간</mark> for their projects and must ensure that their work does not obstruct others.
Tools and equipment are available for shared use, but they must be returned <mark>즉시</mark> after each session.
The registration fee contributes to maintaining facilities, providing materials, and covering instructional costs.`,
  wordPairs: {
    "unless otherwise": "별도로 명시하지 않는 한",
    "be altered": "변경되다",
    explicit: "명시적",
    modifications: "수정 사항",
    "designated spaces": "지정된 공간",
    promptly: "즉시",
  },

  questions: [],
};

const announcement41 = {
  id: "announcement41",
  title: "Community Health Awareness Walk",
  passage: `Step Up for a Healthier Community!

The Oakwood Wellness Foundation is excited to announce its annual Community Health <mark>Awareness Walk</mark>, and we need your support to make it a success. 
Many <mark>individuals</mark> face significant barriers to accessing essential healthcare services, and this event aims to <mark>raise</mark> crucial funds to provide free medical screenings, wellness workshops, and nutrition counseling for <mark>underserved</mark> families.

To help us achieve this goal, we invite you to participate in a 5-kilometer walk at Riverside Park on September 10. 
This family-friendly event is designed to promote an active lifestyle while supporting a <mark>meaningful cause</mark>. 
Participants of all ages and fitness levels are encouraged to join and walk at their own pace.

The entry fee is $30 <mark>through</mark> July, $35 from August 1-20, and $40 on the day of the event. 
All <mark>proceeds</mark> will go directly toward funding healthcare programs that benefit those in need. 
Additionally, participants who walk in a <mark>themed outfit</mark> will be eligible to enter a costume contest, with the winner receiving a $75 gift card to Healthy Living Stores. 
The contest results will be announced during the post-event celebration.

All registered participants will receive a welcome kit, including a reusable water bottle, a <mark>commemorative</mark> <mark>race bib</mark>, and a health tracker to monitor their steps. Those who complete the walk within 90 minutes will receive a special finisher's medal <mark>as a token of achievement</mark>.

Join us in making a difference! Sign up today at www.oakwoodwellness.org/walk and take a step toward a healthier, stronger community.`,

  translation: `더 건강한 커뮤니티를 위해 함께 나서세요!

오크우드 웰니스 재단은 연례 커뮤니티 건강 인식 걷기 행사를 발표하게 되어 기쁘며, 이 행사의 성공을 위해 여러분의 지원이 필요합니다. 많은 개인들이 필수 의료 서비스 접근에 상당한 장벽에 직면하고 있으며, 이 행사는 소외된 가정을 위한 무료 의료 검진, 웰니스 워크숍 및 영양 상담을 제공하기 위한 중요한 기금을 모금하는 것을 목표로 합니다.

이 목표를 달성하기 위해, 9월 10일 리버사이드 공원에서 열리는 5킬로미터 걷기 행사에 참여하시기를 초대합니다. 이 가족 친화적 행사는 의미 있는 목적을 지원하면서 활동적인 생활 방식을 촉진하도록 설계되었습니다. 모든 연령대와 체력 수준의 참가자들이 자신의 페이스로 걸으며 참여하도록 권장됩니다.

참가비는 7월까지 30달러, 8월 1일부터 20일까지 35달러, 행사 당일에는 40달러입니다. 모든 수익금은 도움이 필요한 사람들에게 혜택을 주는 의료 프로그램에 직접 지원됩니다. 또한, 테마 의상을 입고 걷는 참가자들은 코스튬 콘테스트에 참가할 자격이 있으며, 우승자는 건강한 생활 상점에서 사용할 수 있는 75달러 상당의 기프트 카드를 받게 됩니다. 콘테스트 결과는 행사 후 축하 행사 중에 발표될 예정입니다.

등록된 모든 참가자는 재사용 가능한 물병, 기념 레이스 번호표, 그리고 걸음 수를 모니터링하는 건강 트래커가 포함된 웰컴 키트를 받게 됩니다. 90분 이내에 걷기를 완료한 참가자들은 성취의 증표로 특별한 완주자 메달을 받게 됩니다.

변화를 만드는 데 동참하세요! 오늘 www.oakwoodwellness.org/walk에서 등록하고 더 건강하고 강한 커뮤니티를 향한 한 걸음을 내딛으세요.`,
  koreanNouns: `Step Up for a Healthier Community!

The Oakwood Wellness Foundation is excited to announce its annual Community Health <mark>건강 인식 걷기 행사</mark>, and we need your support to make it a success. 
Many <mark>사람들</mark> face significant barriers to accessing essential healthcare services, and this event aims to <mark>모금하다</mark> crucial funds to provide free medical screenings, wellness workshops, and nutrition counseling for <mark>소외된</mark> families.

To help us achieve this goal, we invite you to participate in a 5-kilometer walk at Riverside Park on September 10. 
This family-friendly event is designed to promote an active lifestyle while supporting a <mark>의미 있는 목적</mark>. 
Participants of all ages and fitness levels are encouraged to join and walk at their own pace.

The entry fee is $30 <mark>까지</mark> July, $35 from August 1-20, and $40 on the day of the event. 
All <mark>수익금</mark> will go directly toward funding healthcare programs that benefit those in need. 
Additionally, participants who walk in a <mark>테마 의상</mark> will be eligible to enter a costume contest, with the winner receiving a $75 gift card to Healthy Living Stores. 
The contest results will be announced during the post-event celebration.

All registered participants will receive a welcome kit, including a reusable water bottle, a <mark>기념</mark> <mark>레이스 번호표</mark>, and a health tracker to monitor their steps. Those who complete the walk within 90 minutes will receive a special finisher's medal <mark>성취의 증표로</mark>.

Join us in making a difference! Sign up today at www.oakwoodwellness.org/walk and take a step toward a healthier, stronger community.`,
  wordPairs: {
    "Awareness Walk": "건강 인식 걷기 행사",
    individuals: "사람들",
    raise: "모금하다",
    underserved: "소외된",
    "meaningful cause": "의미 있는 목적",
    through: "까지",
    proceeds: "수익금",
    "themed outfit": "테마 의상",
    commemorative: "기념",
    "race bib": "레이스 번호표",
    "as a token of achievement": "성취의 증표로",
  },

  questions: [],
};

export const announcementQuestions = [
  announcement1,
  announcement2,
  announcement3,
  announcement4,
  announcement5,
  announcement6,
  announcement7,
  announcement8,
  announcement9,
  announcement10,
  announcement11,
  announcement12,
  announcement13,
  announcement14,
  announcement15,
  announcement16,
  announcement17,
  announcement18,
  announcement19,
  announcement20,
  announcement21,
  announcement22,
  announcement23,
  announcement24,

  announcement25,
  announcement27,
  announcement28,
  announcement29,
  announcement30,

  announcement32,
  announcement33,
  announcement34,

  announcement36,
  announcement37,

  announcement39,

  announcement41,
];
